// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T17:25:38.927Z
// Property: Toscana Apartments (ID: 6767906449166942)
// Collections: 16 amenities, 6 floorplans (live), 25 photos, 73 POIs, 2 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166942",
  "property_external_id": "08wxvz0",
  "property_zillow_url": "https://www.zillow.com/apartments/westminster-co/toscana-apartments/Cj8fZF/",
  "property_apartments_url": "https://www.apartments.com/toscana-apartments-arvada-co/08wxvz0/",
  "property_google_business_url": "https://www.google.com/maps/place/Toscana+Apartments/data=!4m2!3m1!1s0x0:0xb6094ce213c7bb83?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "6732006317",
  "property_crm_software": null,
  "property_pm_software": "AIM",
  "property_pm_info": "1138TOSC",
  "property_status": null,
  "property_slug": "toscana-apartments",
  "property_name": "Toscana Apartments",
  "property_website_url": "https://www.liveattoscana.com/",
  "property_domain": "https://www.liveattoscana.com/",
  "property_address": "8490 Sheridan Boulevard",
  "property_full_address": "8490 Sheridan Blvd, Arvada, CO 80003",
  "property_address_1": "8490 Sheridan Blvd",
  "property_address_2": null,
  "property_address_city": "Arvada",
  "property_address_state": "CO",
  "property_address_zip_full": null,
  "property_address_zip": "80003",
  "property_address_country": "US",
  "property_address_county": "Adams County",
  "property_neighborhood_address": "South Westminster",
  "property_address_latitude": "39.8502042",
  "property_address_longitude": "-105.0517231",
  "property_email": null,
  "property_phone": "3034272700",
  "property_call_tracking_phone": null,
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Toscana Apartments in Arvada, CO, your ideal living space awaits. Choose from stylish studio, one, or two-bedroom floor plans and enjoy a vibrant community complete with a refreshing pool, pet-friendly dog park, and welcoming clubhouse. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "**Welcome to Toscana Apartments in Arvada, CO – Your Ideal Home Awaits!**\n\nDiscover the perfect blend of comfort and convenience at Toscana Apartments, where a variety of thoughtfully designed floor plans await you. Choose from cozy Studios, spacious One Bedrooms, or family-friendly Two Bedrooms, each tailored to suit your lifestyle. \n\nOur community boasts an impressive array of amenities to enhance your living experience. Dive into relaxation at our inviting pool, enjoy sunny afternoons at our picnic area, or let the kids explore our vibrant playground. The clubhouse offers a perfect gathering space, equipped with a lounge and multi-use room for social gatherings. For gaming enthusiasts, our gameroom is ready for some friendly competition!\n\nWe cater to modern living with features like high-speed internet access, on-site laundry facilities, and a dedicated business center, ensuring you stay connected and productive. Pet owners will appreciate our spacious dog park and pet play area, designed for your furry friends to enjoy. \n\nEach apartment is designed for comfort, featuring air conditioning, heating, walk-in closets, and modern kitchens equipped with a range, oven, refrigerator, and dishwasher. Unwind after a long day by your cozy fireplace or enjoy your morning coffee on your private balcony or patio.\n\nToscana Apartments is ideally located in the heart of Arvada, offering easy access to shopping, dining, and recreational activities. Whether you're looking for a serene retreat or a vibrant community, Toscana has it all. \n\nFind your new home today – browse our availability or schedule a tour to visit our community! Your ideal lifestyle awaits at Toscana Apartments.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
  "property_featured_image_media": {
    "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
    "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
    "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
    "width": 1161,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "252",
  "property_year_built": "1985",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.60317460317461",
  "property_admin_fee": "0",
  "property_application_fee": "63.50",
  "property_fees_deposit_info": "Deposit: $500-1000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "160",
  "property_pet_restrictions": "We welcome cats and dogs with a combined weight not to exceed 160 lbs. Maximum 2 pets per apartment home.",
  "property_pet_policy_description": "We welcome cats and dogs with a combined weight not to exceed 160 lbs. Maximum 2 pets per apartment home. Pet deposit: $300. Monthly pet rent: $35.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://myrentalapplication.com/index/amctoscana",
  "property_resident_portal_url": "https://toscana.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amctoscana",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1ae6-7274-95d3-fb31eec9cc19.webp",
  "property_primary_logo_media": {
    "alt_text": "Toscana logo",
    "public_id": "019d02d3-1ae6-7274-95d3-fb31eec9cc19",
    "storage_key": "property/6767906449166942/019d02d3-1ae6-7274-95d3-fb31eec9cc19.webp",
    "width": 1166,
    "height": 214
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1ae6-7274-95d3-fb31eec9cc19.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Toscana logo",
    "public_id": "019d02d3-1ae6-7274-95d3-fb31eec9cc19",
    "storage_key": "property/6767906449166942/019d02d3-1ae6-7274-95d3-fb31eec9cc19.webp",
    "width": 1166,
    "height": 214
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-c34f-7208-a73c-ee4812ac1272.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Toscana logo",
    "public_id": "019d02d5-c34f-7208-a73c-ee4812ac1272",
    "storage_key": "property/6767906449166942/019d02d5-c34f-7208-a73c-ee4812ac1272.webp",
    "width": 640,
    "height": 117
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#063140",
  "property_secondary_color": "#24586F",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "520 - 900",
  "property_sqft_min": "520",
  "property_sqft_max": "900",
  "property_price_range": "$999 - $1399",
  "property_price_min": "999",
  "property_price_max": "1399",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/ToscanaAptHomes/",
  "property_instagram_url": "https://www.instagram.com/toscanaapthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJdbWd2MqJa4cRg7vHE-JMCbY",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/toscana-westminster-3",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Toscana Apartments",
  "property_home_romance_title": "Find Your Ideal Sanctuary, Where Comfort Meets Connection",
  "property_home_amenities_blurb": "Welcome to Toscana Apartments in Arvada, CO, where comfort meets convenience. Choose from stylish studio, one, or two-bedroom layouts, and indulge in exceptional amenities—relax by the pool, unwind in our clubhouse, or take your furry friend to the dog park. Your perfect home awaits with us!",
  "property_home_floorplans_blurb": "Welcome to Toscana Apartments in Arvada, CO, where comfort meets style. Choose from our thoughtfully designed studio, one-bedroom, and two-bedroom floor plans tailored for your unique lifestyle. Uncover the space that resonates with you and elevate your living experience. Take a step towards your new home today!",
  "property_home_gallery_blurb": "Welcome to Toscana Apartments in Arvada, CO, where modern living meets comfort. Choose from spacious studio, one, or two-bedroom floor plans, and enjoy amenities like a refreshing pool, a pet-friendly dog park, and a vibrant clubhouse. Picture yourself living here, where every detail enhances your lifestyle!",
  "property_home_neighborhood_blurb": "Welcome to Toscana Apartments in vibrant Arvada, CO, where comfort meets convenience. With stylish studios to spacious two-bedroom layouts, you’ll love your new home. Enjoy nearby parks, exceptional schools, and cultural gems like the Arvada Center for the Arts. Experience effortless living amidst local favorites and a thriving community.",
  "property_home_reviews_blurb": "At Toscana Apartments in Arvada, CO, you'll find a vibrant community where neighbors become friends and fun is abundant. With a dedicated office team ensuring a seamless living experience, residents rave about their new home: “The value for the rent is very good.” Join our thriving neighborhood and experience it for yourself!",
  "property_neighborhood_blurb": "At Toscana Apartments in Arvada, CO, vibrant living meets endless exploration. Nestled near the stunning Two Ponds National Wildlife Refuge, art at the Arvada Center, and green spaces like Ralston Central Park, your new home offers unparalleled access to both nature and culture. Elevate your lifestyle and uncover community treasures nearby.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Toscana Apartments in Arvada, CO, every detail is designed for comfort and connection. Choose from spacious studios or fashionable two-bedroom layouts, all featuring modern amenities. Dive into our refreshing pool, relax in the clubhouse, or enjoy a day at the dog park. Experience the blend of convenience and relaxation today!",
  "property_applynow_blurb": "At Toscana Apartments in Arvada, CO, your ideal home awaits! Choose from stylish studio, one, or two-bedroom floor plans, complete with modern amenities like high-speed internet, walk-in closets, and cozy fireplaces. With inviting spaces like a sparkling pool, dog park, and clubhouse, it's time to elevate your living experience. Apply now and lease online today!",
  "property_contactus_blurb": "At Toscana Apartments in Arvada, CO, your perfect home awaits with thoughtfully designed studio, one-bedroom, and two-bedroom floor plans. Embrace community living with endless amenities and vibrant surroundings. Have questions? Contact our leasing team today to find the ideal space that complements your lifestyle!",
  "property_faqs_blurb": "At Toscana Apartments in Arvada, CO, your perfect home awaits, whether it’s a cozy studio or a spacious two-bedroom. Nestle into a vibrant community thoughtfully designed for comfort. Got questions? Dive into our FAQs page to uncover everything you need to know about living at Toscana!",
  "property_floorplans_blurb": "At Toscana Apartments in Arvada, CO, you'll find a variety of floor plans tailored to suit your lifestyle. Choose from cozy studios, spacious one-bedrooms, or inviting two-bedrooms. Each design offers comfort and charm. Browse our available apartment homes today and find the perfect layout that feels like home.",
  "property_gallery_blurb": "At Toscana Apartments in Arvada, CO, imagine a vibrant lifestyle where your dream home meets exceptional amenities. Choose from stylish studio, one, or two-bedroom floor plans. Relax by the pool, enjoy sunny picnics at the grill, or unwind in our cozy clubhouse. Picture yourself living here, where comfort and convenience unite!",
  "property_interactivemap_blurb": "At Toscana Apartments in Arvada, CO, our vibrant community blends comfort and convenience! Choose from spacious studio, one, or two-bedroom layouts, and embrace amenities like a sparkling pool, dog park, and cozy gameroom. Ready to find your perfect home? Use our interactive community map to start your journey today!",
  "property_pets_blurb": "At Toscana Apartments in Arvada, CO, your furry friends are part of the family! With spacious homes designed for both comfort and style, our pet-friendly community allows up to two pets, ensuring your companions enjoy life as much as you do. Unleash happiness together amidst beautiful surroundings!",
  "property_referafriend_blurb": "At Toscana Apartments in Arvada, CO, we believe great friends make great neighbors! With inviting studio, one-bedroom, and two-bedroom floor plans, your perfect home awaits. Share the joy of our vibrant community—refer a friend today and enjoy the rewards of living close to those who matter most!",
  "property_residentaccess_blurb": "Welcome to Toscana Apartments in Arvada, CO, where diverse floor plans—including studios, one-bedroom, and two-bedroom apartments—cater to your unique lifestyle. Take advantage of our resident portal for hassle-free rent payments, maintenance requests, and community updates. Your comfortable home awaits—log in and enjoy seamless living today!",
  "property_reviews_blurb": "At Toscana Apartments in Arvada, CO, our residents rave about the extraordinary sense of community and exceptional support from our office staff. With words like, \"The office staff has been extremely helpful... we're close to the highway, stores, entertainment,\" it’s clear why living here is both fun and rewarding! See what our residents have to say about living at our community!",
  "property_created_at": "1764627491384",
  "property_scheduletour_blurb": "At Toscana Apartments in Arvada, CO, choose from thoughtfully designed studio, one-bedroom, and two-bedroom floor plans that cater to your lifestyle. Schedule a tour today and experience vibrant living in our community. Curious about life here? Check out our residents' testimonials for a glimpse into their Tuscany-inspired home.",
  "property_thankyou_blurb": "Thank you for reaching out! At Toscana Apartments in Arvada, CO, we offer a range of thoughtfully designed floor plans, including cozy studios, spacious one-bedroom, and comfortable two-bedroom options. Your home awaits—our team will be in touch soon to guide you on your journey to exceptional living!",
  "property_virtualtours_blurb": "Step into your dream home at Toscana Apartments in Arvada, CO. Our diverse floor plans, from cozy studios to spacious two-bedrooms, are designed for modern living. Experience the inviting atmosphere and beautiful amenities—take a virtual tour today and envision your new life with us!",
  "property_copyright": "2025 All Rights Reserved. Toscana Apartments",
  "property_seo_title_home": "Toscana Apartments |  Apartments in Arvada, CO",
  "property_seo_description_home": "Welcome to Toscana Apartments in Arvada, CO! Choose from spacious studios, one & two bedrooms with top-notch amenities. Your ideal home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Arvada, CO Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Toscana Apartments in Arvada, CO! From cozy studios to spacious two-bedrooms, browse our floor plans and embrace your new home.",
  "property_seo_title_amenities": "Amenities | Arvada, CO Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Toscana Apartments in Arvada, CO, featuring a pool, clubhouse, and pet-friendly spaces. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Arvada, CO",
  "property_seo_description_gallery": "Picture yourself at Toscana Apartments in Arvada, CO! Enjoy stunning floor plans, vibrant amenities, and a pet-friendly community. Your ideal home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Toscana Apartments Apartments",
  "property_seo_description_virtualtours": "Step into Toscana Apartments in Arvada, CO! Experience your future home with a virtual tour of our stylish studios, one, and two-bedroom floor plans.",
  "property_seo_title_interactivemap": "Interactive Map | Toscana Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Toscana Apartments in Arvada, CO. Use our interactive map to explore available studios, one, and two-bedroom options today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Arvada, CO",
  "property_seo_description_neighborhood": "Uncover the charm of Arvada from Toscana Apartments. Enjoy vibrant local favorites and nearby attractions. Your ideal neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | Toscana Apartments",
  "property_seo_description_contact": "Connect with Toscana Apartments in Arvada, CO! We're ready to answer your questions about our studio, one, and two-bedroom floor plans. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Arvada, CO",
  "property_seo_description_faqs": "Your questions answered! Visit Toscana Apartments' FAQs to learn about our Arvada community's amenities, floor plans, and pet-friendly features.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Arvada, CO",
  "property_seo_description_reviews": "Join the Toscana Apartments family in Arvada, CO! Check out our resident reviews and see why our vibrant community and amenities make home truly special.",
  "property_seo_title_applynow": "Apply Now | Apartments in Arvada, CO",
  "property_seo_description_applynow": "Discover vibrant living at Toscana Apartments in Arvada, CO! Enjoy spacious plans, great amenities, and a welcoming community. Apply today!",
  "property_seo_title_residentaccess": "Resident Access | Toscana Apartments",
  "property_seo_description_residentaccess": "Access Toscana Apartments' resident portal in Arvada, CO. Effortlessly pay rent, schedule maintenance, and manage your living experience online today!",
  "property_seo_title_referafriend": "Refer A Friend | Toscana Apartments",
  "property_seo_description_referafriend": "Refer a friend to Toscana Apartments in Arvada, CO! Great friends make great neighbors—enjoy a vibrant community together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Toscana Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Toscana Apartments in Arvada, CO. Schedule a tour today and find your perfect home in a vibrant community filled with amenities!",
  "property_seo_title_privacy": "Privacy Policy | Toscana Apartments",
  "property_seo_description_privacy": "Toscana Apartments in Arvada, CO, values your privacy. Dive into our policy to see how we protect your personal information. Your trust matters to us!",
  "property_seo_title_accessibility": "Website Accessibility | Toscana Apartments",
  "property_seo_description_accessibility": "Discover inclusivity at Toscana Apartments in Arvada, CO—where everyone feels at home. Join us in creating enjoyable moments for all!",
  "property_seo_title_sitemap": "Sitemap | Toscana Apartments",
  "property_seo_description_sitemap": "Uncover every corner of Toscana Apartments in Arvada, CO! Navigate our sitemap to find your ideal home and amenities that fit your lifestyle seamlessly.",
  "property_seo_title_thankyou": "Thank You | Toscana Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to luxury living at Toscana Apartments in Arvada is just beginning. Expect our team to connect with you soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Arvada, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1786637317822",
  "amenities": [
    {
      "id": "ec_cde6fbd59ab9cb088d141e54",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Convenient to RTD Park & Ride",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a19c3240c1c913f074dfd1e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Close to Great Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_981973aacd263cee1f824a9f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Laundry Facilities Open 8:00 am‑10:00 pm",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc519204c13cf2fde6bebda7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31df250dd01a7b9959be5bff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Internet Cafe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2b669acbb11ad13bdb9d877",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "24 hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e62ff213c2f339879f3631ef",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Barbeque Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3eb4af456945e17a9d1d5c6f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Gated Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a8712b4fde97b97633c829e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_23797bbd4906475b5719d63b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69b2e10130cfc50fd82b7d4c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a6f90955eb30a8d3e62c3ff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Walk In Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad3dca4edec3757b8ddbe745",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Mirrored Closet Doors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d33521ce7090b9fd4fc40410",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Wood‑Burning Fireplaces",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72c7593668e75caa4897070e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Tile Entry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acfbb282cd582018256171d2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "external_id": "false",
      "title": "Beautifully Updated Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_9f9d1fd4-7f1a-4d62-83c6-7eb89c744be3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-a359-715e-bca1-584a66ef0951.webp",
      "image_media": {
        "alt_text": "Community lounge area with fireplace, seating, and a TV.",
        "public_id": "019d02d5-a359-715e-bca1-584a66ef0951",
        "storage_key": "property/6767906449166942/019d02d5-a359-715e-bca1-584a66ef0951.webp",
        "width": 927,
        "height": 618
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable community lounge, featuring a cozy fireplace and ample seating for residents.",
      "link": "",
      "alt_text": "Community lounge area with fireplace, seating, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5da1f439-ed98-4f59-a160-4384d0eb7c68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-a1b3-75e9-83c2-86ee2c663d6c.webp",
      "image_media": {
        "alt_text": "Lounge area with two striped armchairs, a dark leather sofa, and a coffee table with a decorative item.",
        "public_id": "019d02d5-a1b3-75e9-83c2-86ee2c663d6c",
        "storage_key": "property/6767906449166942/019d02d5-a1b3-75e9-83c2-86ee2c663d6c.webp",
        "width": 926,
        "height": 618
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable lounge area, perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Lounge area with two striped armchairs, a dark leather sofa, and a coffee table with a decorative item.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_751e38cc-a412-40d0-a3c0-d37617fcae36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-a2b0-77b4-a7c5-2e45e147acb1.webp",
      "image_media": {
        "alt_text": "Community lounge area with comfortable seating and a television.",
        "public_id": "019d02d5-a2b0-77b4-a7c5-2e45e147acb1",
        "storage_key": "property/6767906449166942/019d02d5-a2b0-77b4-a7c5-2e45e147acb1.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Relax in the community lounge, featuring plush seating, a large television, and a quiet workspace with computers.",
      "link": "",
      "alt_text": "Community lounge area with comfortable seating and a television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a839233b-2170-45e6-865b-c7a1afd24003",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-a035-763c-8b6e-efc33a2e9717.webp",
      "image_media": {
        "alt_text": "Computer lab with workstations, printer, and a round glass table with chairs.",
        "public_id": "019d02d5-a035-763c-8b6e-efc33a2e9717",
        "storage_key": "property/6767906449166942/019d02d5-a035-763c-8b6e-efc33a2e9717.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Utilize the convenient computer lab, equipped with workstations and a printer, perfect for work or study. Relax at the nearby seating area with a round glass table and chairs.",
      "link": "",
      "alt_text": "Computer lab with workstations, printer, and a round glass table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8d0942bb-0a1e-431c-8ac7-ecaa87046cab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-91e7-73ab-9554-7f3c8eda9445.webp",
      "image_media": {
        "alt_text": "White picket fence surrounds a grassy backyard with two trees and a bench.",
        "public_id": "019d02d5-91e7-73ab-9554-7f3c8eda9445",
        "storage_key": "property/6767906449166942/019d02d5-91e7-73ab-9554-7f3c8eda9445.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy your private, fenced-in backyard, perfect for relaxing or outdoor activities.",
      "link": "",
      "alt_text": "White picket fence surrounds a grassy backyard with two trees and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_216ca787-2012-4ee4-a272-371b9e14e7ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-8b60-74cf-b185-a54c4092ea75.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and fenced dog park at apartment complex.",
        "public_id": "019d02d5-8b60-74cf-b185-a54c4092ea75",
        "storage_key": "property/6767906449166942/019d02d5-8b60-74cf-b185-a54c4092ea75.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the pool or let your furry friends play in the dedicated dog park at our community amenities.",
      "link": "",
      "alt_text": "Outdoor swimming pool and fenced dog park at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd9d11f3-e796-4c98-963a-600b488e2035",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-8815-7209-bd1d-660cf3199f93.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with red and tan siding, balconies, and outdoor staircases, overlooking a grassy courtyard.",
        "public_id": "019d02d5-8815-7209-bd1d-660cf3199f93",
        "storage_key": "property/6767906449166942/019d02d5-8815-7209-bd1d-660cf3199f93.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Discover comfortable living in this multifamily apartment complex, featuring a well-maintained exterior with spacious balconies and convenient outdoor access.",
      "link": "",
      "alt_text": "Exterior view of a multifamily apartment building with red and tan siding, balconies, and outdoor staircases, overlooking a grassy courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_478d366a-e4b5-445b-86e1-26dd2d14b128",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-86c5-715d-a8b3-ee6bf71e8a03.webp",
      "image_media": {
        "alt_text": "White picket fence surrounding a grassy backyard with two trees and a hillside in the background.",
        "public_id": "019d02d5-86c5-715d-a8b3-ee6bf71e8a03",
        "storage_key": "property/6767906449166942/019d02d5-86c5-715d-a8b3-ee6bf71e8a03.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy your private backyard with a charming white picket fence, perfect for relaxing or entertaining. Includes a grassy lawn and scenic hillside views.",
      "link": "",
      "alt_text": "White picket fence surrounding a grassy backyard with two trees and a hillside in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_010a9919-bab7-473d-b4af-6b887cc8be5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-84dd-721d-95ab-6241652ad6e4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and picnic tables.",
        "public_id": "019d02d5-84dd-721d-95ab-6241652ad6e4",
        "storage_key": "property/6767906449166942/019d02d5-84dd-721d-95ab-6241652ad6e4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and convenient picnic areas for al fresco dining.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and picnic tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8178bd32-0bc3-4aa1-99c0-0735e21fa09d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-7fb7-70f3-a033-f6b480003a21.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with landscaping and parked cars.",
        "public_id": "019d02d5-7fb7-70f3-a033-f6b480003a21",
        "storage_key": "property/6767906449166942/019d02d5-7fb7-70f3-a033-f6b480003a21.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Charming apartment buildings set against a backdrop of lush trees and vibrant flower beds. This community offers a welcoming atmosphere with convenient parking.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with landscaping and parked cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_faced094-cdd5-4af4-95bc-b4b5e6686f6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-7b8d-76c8-a3d3-f88dfa342d40.webp",
      "image_media": {
        "alt_text": "Leasing center entrance with pool and landscaping",
        "public_id": "019d02d5-7b8d-76c8-a3d3-f88dfa342d40",
        "storage_key": "property/6767906449166942/019d02d5-7b8d-76c8-a3d3-f88dfa342d40.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Welcome to the leasing center and refreshing outdoor pool area, surrounded by beautiful landscaping and mature trees.",
      "link": "",
      "alt_text": "Leasing center entrance with pool and landscaping",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d6f4f580-20c6-4b60-a4d6-ff3f1439985b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-796e-700f-a18a-7c561a5dde7c.webp",
      "image_media": {
        "alt_text": "Playground with slides, climbing structures, and benches.",
        "public_id": "019d02d5-796e-700f-a18a-7c561a5dde7c",
        "storage_key": "property/6767906449166942/019d02d5-796e-700f-a18a-7c561a5dde7c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, complete with slides and climbing structures for children.",
      "link": "",
      "alt_text": "Playground with slides, climbing structures, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aab6b0a2-d135-4c2d-8ec8-10082a831115",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-749a-74e9-bf30-9bcd803024e8.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, kitchen, and dining area.",
        "public_id": "019d02d5-749a-74e9-bf30-9bcd803024e8",
        "storage_key": "property/6767906449166942/019d02d5-749a-74e9-bf30-9bcd803024e8.webp",
        "width": 800,
        "height": 533
      },
      "title": "Apartment",
      "description": "Comfortable living room featuring a fireplace, adjacent dining area, and a full kitchen, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Living room with fireplace, kitchen, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ec6f0d4-f826-40ec-872a-efc0094bddc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-7182-76eb-914d-c71a80ec382e.webp",
      "image_media": {
        "alt_text": "Dining area with glass-top table and chairs, next to a kitchen counter and black refrigerator.",
        "public_id": "019d02d5-7182-76eb-914d-c71a80ec382e",
        "storage_key": "property/6767906449166942/019d02d5-7182-76eb-914d-c71a80ec382e.webp",
        "width": 800,
        "height": 533
      },
      "title": "Apartment",
      "description": "Enjoy a meal in your dining area, featuring a stylish glass-top table and comfortable chairs. The adjacent kitchen counter and full-size refrigerator make this space both functional and elegant.",
      "link": "",
      "alt_text": "Dining area with glass-top table and chairs, next to a kitchen counter and black refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1da2be0d-a33f-48ab-8c5c-ae0c6d3c9800",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-6a41-7497-9045-1c14b772ec77.webp",
      "image_media": {
        "alt_text": "Living room with a light blue sectional couch, coffee table, and a desk with a laptop.",
        "public_id": "019d02d5-6a41-7497-9045-1c14b772ec77",
        "storage_key": "property/6767906449166942/019d02d5-6a41-7497-9045-1c14b772ec77.webp",
        "width": 926,
        "height": 618
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional couch, a dedicated workspace with a desk and laptop, and an open kitchen area.",
      "link": "",
      "alt_text": "Living room with a light blue sectional couch, coffee table, and a desk with a laptop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1bafa74f-01d3-4521-80b5-b4712d586b09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-6879-77ac-a965-4a839b01f5c7.webp",
      "image_media": {
        "alt_text": "Living room with a light blue sofa, a fireplace, and a desk with a laptop.",
        "public_id": "019d02d5-6879-77ac-a965-4a839b01f5c7",
        "storage_key": "property/6767906449166942/019d02d5-6879-77ac-a965-4a839b01f5c7.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room, complete with a cozy fireplace and a dedicated workspace.",
      "link": "",
      "alt_text": "Living room with a light blue sofa, a fireplace, and a desk with a laptop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c62855d8-e21b-428d-b803-48e39cf47c41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-68c7-72be-9bad-9569772a271b.webp",
      "image_media": {
        "alt_text": "Living room with a light blue sectional sofa, ottoman, entertainment center with TV, and a red tray with a wine bottle and glasses.",
        "public_id": "019d02d5-68c7-72be-9bad-9569772a271b",
        "storage_key": "property/6767906449166942/019d02d5-68c7-72be-9bad-9569772a271b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable living room, featuring a stylish sectional sofa, entertainment center, and a decorative tray for your evening drinks.",
      "link": "",
      "alt_text": "Living room with a light blue sectional sofa, ottoman, entertainment center with TV, and a red tray with a wine bottle and glasses.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6ef2b55d-fd69-4037-bb56-7b7233e3d0cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-66f5-7230-8658-77fce159b89c.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, beige countertops, stainless steel sink, dishwasher, and a white oven.",
        "public_id": "019d02d5-66f5-7230-8658-77fce159b89c",
        "storage_key": "property/6767906449166942/019d02d5-66f5-7230-8658-77fce159b89c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring light wood cabinetry, ample counter space, and modern appliances including a dishwasher and oven.",
      "link": "",
      "alt_text": "Kitchen with light wood cabinets, beige countertops, stainless steel sink, dishwasher, and a white oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_45d2dd9e-e62b-4e52-a301-2bd2de038b44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-5d33-77eb-896a-cca14bbdddc2.webp",
      "image_media": {
        "alt_text": "Bedroom with a white metal bed, blue pillows, and a patterned comforter.",
        "public_id": "019d02d5-5d33-77eb-896a-cca14bbdddc2",
        "storage_key": "property/6767906449166942/019d02d5-5d33-77eb-896a-cca14bbdddc2.webp",
        "width": 800,
        "height": 533
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed with decorative pillows and a vibrant comforter, perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a white metal bed, blue pillows, and a patterned comforter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31c93f3e-21c4-4c70-8fb1-c00373ebc1c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d5-5d34-719d-a3c6-36bc72ae0d8f.webp",
      "image_media": {
        "alt_text": "Queen-size bed with striped bedding and a floral painting on the wall.",
        "public_id": "019d02d5-5d34-719d-a3c6-36bc72ae0d8f",
        "storage_key": "property/6767906449166942/019d02d5-5d34-719d-a3c6-36bc72ae0d8f.webp",
        "width": 800,
        "height": 533
      },
      "title": "Apartment",
      "description": "A comfortable bedroom featuring a queen-size bed with stylish striped bedding, a decorative floral painting, and ample natural light from the window.",
      "link": "",
      "alt_text": "Queen-size bed with striped bedding and a floral painting on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_02c03f23-83c1-4e97-ae6c-ecba97c08ab5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-5dc9-73fa-89da-02e7206c8c8d.webp",
      "image_media": {
        "alt_text": "Dining area with a glass-top table, four chairs, and a view into the kitchen.",
        "public_id": "019d02d4-5dc9-73fa-89da-02e7206c8c8d",
        "storage_key": "property/6767906449166942/019d02d4-5dc9-73fa-89da-02e7206c8c8d.webp",
        "width": 500,
        "height": 333
      },
      "title": "Apartment",
      "description": "Enjoy meals in this inviting dining area, perfect for everyday living and entertaining guests. The space seamlessly connects to the kitchen.",
      "link": "",
      "alt_text": "Dining area with a glass-top table, four chairs, and a view into the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0eee17fe-d249-4a31-9da6-d4866584252a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-50bf-7659-b578-3de99832801b.webp",
      "image_media": {
        "alt_text": "Business center with computers and seating area",
        "public_id": "019d02d4-50bf-7659-b578-3de99832801b",
        "storage_key": "property/6767906449166942/019d02d4-50bf-7659-b578-3de99832801b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Utilize the on-site business center, complete with computers and a comfortable seating area, perfect for staying connected or getting work done.",
      "link": "",
      "alt_text": "Business center with computers and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cac3a630-226a-41c4-a4d4-5d0735aebc47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-4f44-77eb-a9cd-744a313260b1.webp",
      "image_media": {
        "alt_text": "Modern living room with a light blue sectional sofa, fireplace, desk with laptop, and entertainment center with TV.",
        "public_id": "019d02d4-4f44-77eb-a9cd-744a313260b1",
        "storage_key": "property/6767906449166942/019d02d4-4f44-77eb-a9cd-744a313260b1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable sectional sofa, a cozy fireplace, a dedicated workspace with a laptop, and an entertainment center with a television.",
      "link": "",
      "alt_text": "Modern living room with a light blue sectional sofa, fireplace, desk with laptop, and entertainment center with TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b64ddb4b-d40f-4714-b402-795d67878466",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-43ab-75dc-b374-189081e6b27d.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies and staircases during sunset.",
        "public_id": "019d02d4-43ab-75dc-b374-189081e6b27d",
        "storage_key": "property/6767906449166942/019d02d4-43ab-75dc-b374-189081e6b27d.webp",
        "width": 666,
        "height": 444
      },
      "title": "Community",
      "description": "Exterior view of an apartment complex featuring multiple buildings with balconies, staircases, and manicured landscaping at sunset.",
      "link": "",
      "alt_text": "Apartment building exterior with balconies and staircases during sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d643f598-809f-4af0-8faf-bcd7eac8b6de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "title": "Community",
      "description": "Welcome to Toscana Apartment Homes, a community offering comfortable living in a beautiful setting. Our monument sign is surrounded by vibrant flowers and lush greenery, leading you to our apartment buildings.",
      "link": "",
      "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e831771c-0458-4e0c-bd4f-f3911318c5da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Morning Story - Arvada",
      "poi_type": "Restaurants",
      "poi_address": "8025 Sheridan Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "Brunch institution offering classic eats like pancakes and French toast, plus cocktails like mimosas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-995c-749e-879d-03ee505789da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-995c-749e-879d-03ee505789da",
        "storage_key": "property/6767906449166942/019d02d3-995c-749e-879d-03ee505789da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.morningstoryrestaurant.com/colorado/arvada",
      "poi_directions_map_url": "https://maps.google.com/?cid=10070907811401091071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morning-story---arvada",
      "poi_latitude": "39.8430033",
      "poi_longitude": "-105.0541372",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 303-577-0070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-9fd8da389c73",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxV4JbKJa4cR_8dE6EsNw4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_9daeaf54-c8c6-4f78-93da-9a8a7da7dd0a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Sushi YaYa",
      "poi_type": "Restaurants",
      "poi_address": "8025 Sheridan Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "Sushi rolls, bento boxes, and sake are offered at this small and casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-98fe-746f-9745-158c96b843f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-98fe-746f-9745-158c96b843f8",
        "storage_key": "property/6767906449166942/019d02d3-98fe-746f-9745-158c96b843f8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://sushiyayaxpress.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15542566577977451622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-yaya",
      "poi_latitude": "39.8433117",
      "poi_longitude": "-105.0538964",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 303-426-7669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-9fd8da389c73",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkbp3RjaIa4cRZmQ0YvRJstc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_c2db3da4-10c4-4c42-860c-fe54063bfa5c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "J's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "8075 Sheridan Blvd # A, Arvada, CO 80003, USA",
      "poi_short_description": "Unassuming shop serving up hearty helpings of familiar Chinese fare for takeout & delivery.",
      "poi_long_description": "Unassuming shop serving up hearty helpings of familiar Chinese fare for takeout & delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-9933-719c-bd26-04192cfde928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-9933-719c-bd26-04192cfde928",
        "storage_key": "property/6767906449166942/019d02d3-9933-719c-bd26-04192cfde928.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://jscafearvada.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=661773728938256170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "js-cafe",
      "poi_latitude": "39.8439691",
      "poi_longitude": "-105.0555339",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 303-429-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-9fd8da389c73",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgbgjDjaIa4cRKucMQ7MXLwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_2ab4ed64-9c99-42c0-9124-cf2b4c68c1fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "DAE GEE KOREAN BBQ",
      "poi_type": "Restaurants",
      "poi_address": "7570 Sheridan Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "Chill restaurant focusing on all-you-can-eat Korean BBQ & other comfort fare in a hip environment.",
      "poi_long_description": "Chill restaurant focusing on all-you-can-eat Korean BBQ & other comfort fare in a hip environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-9934-7210-8f68-3f7c0aae305e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-9934-7210-8f68-3f7c0aae305e",
        "storage_key": "property/6767906449166942/019d02d3-9934-7210-8f68-3f7c0aae305e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.daegee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5017917066813440945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dae-gee-korean-bbq",
      "poi_latitude": "39.8334187",
      "poi_longitude": "-105.0525854",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 720-540-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-9fd8da389c73",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwXpIz-Ia4cRsQPJd_w4o0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_914cb87d-5ad5-415f-8ef2-2182d5ec5035",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Black Rock Coffee Bar",
      "poi_type": "Restaurants",
      "poi_address": "7630 W 80th Ave, Arvada, CO 80005, USA",
      "poi_short_description": "Contemporary coffee chain serving classic, specialty & iced espresso beverages, plus smoothies.",
      "poi_long_description": "Contemporary coffee chain serving classic, specialty & iced espresso beverages, plus smoothies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-9f70-737a-8a35-ee5cf6b31f0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-9f70-737a-8a35-ee5cf6b31f0f",
        "storage_key": "property/6767906449166942/019d02d3-9f70-737a-8a35-ee5cf6b31f0f.webp",
        "width": 1145,
        "height": 1280
      },
      "poi_business_url": "https://br.coffee/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5059541796297392766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-rock-coffee-bar",
      "poi_latitude": "39.8413039",
      "poi_longitude": "-105.0829876",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 833-843-5776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2981-7743-ab99-6b35c5eeb664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2981-7743-ab99-6b35c5eeb664",
        "storage_key": "property/6767906449166942/019d02d4-2981-7743-ab99-6b35c5eeb664.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJY7oQvNmJa4cRfkKMBnUaN0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_05b6c45b-280e-45fe-ae8c-8ff484455e98",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Rusty Taco",
      "poi_type": "Restaurants",
      "poi_address": "7630 W 80th Ave, Arvada, CO 80005, USA",
      "poi_short_description": "Homegrown mini-chain serving a variety of tacos, breakfast fare, beer & margaritas in festive digs.",
      "poi_long_description": "Homegrown mini-chain serving a variety of tacos, breakfast fare, beer & margaritas in festive digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-a016-761f-921e-71d17cff5ffb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-a016-761f-921e-71d17cff5ffb",
        "storage_key": "property/6767906449166942/019d02d3-a016-761f-921e-71d17cff5ffb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rustytaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5274319690179177069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rusty-taco",
      "poi_latitude": "39.8413114",
      "poi_longitude": "-105.0829867",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-432-0943",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-9fd8da389c73",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8SPVzP6Ia4cRbWr6TNAlMkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1a2c84f5-592b-4a49-93a5-ee6ee9b535d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "The Butchery- Steaks, Chops & Seafood",
      "poi_type": "Restaurants",
      "poi_address": "7923 Allison Way, Arvada, CO 80005, USA",
      "poi_short_description": "Laid-back, brick-accented American steakhouse offering seafood, chops & daily happy-hour specials.",
      "poi_long_description": "Laid-back, brick-accented American steakhouse offering seafood, chops & daily happy-hour specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-9fdd-706d-aa81-c6a37c88386d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-9fdd-706d-aa81-c6a37c88386d",
        "storage_key": "property/6767906449166942/019d02d3-9fdd-706d-aa81-c6a37c88386d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thebutcheryarvada.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9832069250807154556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-butchery--steaks-chops--seafood",
      "poi_latitude": "39.8396437",
      "poi_longitude": "-105.0872",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-425-1962",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-9fd8da389c73",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-RQlmPuIa4cRfMdmHeSGcog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_9db850c2-7247-4c08-a599-5248eaa8c310",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Teocalli Cocina",
      "poi_type": "Restaurants",
      "poi_address": "5770 Olde Wadsworth Blvd, Arvada, CO 80002, USA",
      "poi_short_description": "Casual restaurant serving Mexican dishes with a focus on corn, plus gluten-free options, and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-a146-711e-aeaa-b485b7b9e5b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-a146-711e-aeaa-b485b7b9e5b1",
        "storage_key": "property/6767906449166942/019d02d3-a146-711e-aeaa-b485b7b9e5b1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.teocallicocina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1056745723136759401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teocalli-cocina",
      "poi_latitude": "39.80171680000001",
      "poi_longitude": "-105.0810638",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-923-3170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-9fd8da389c73",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu5EN-KCHa4cRadZ65aJQqg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d7a7528d-60f0-4531-b9f4-72f2f72fefa9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "303 Ramen",
      "poi_type": "Restaurants",
      "poi_address": "5725 Yukon St, Arvada, CO 80002, USA",
      "poi_short_description": "Japanese ramen, appetizers & diverse Asian entrees served in a no-frills space with patio tables.",
      "poi_long_description": "Japanese ramen, appetizers & diverse Asian entrees served in a no-frills space with patio tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-a759-7710-ad7d-5ca5dc21f4f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-a759-7710-ad7d-5ca5dc21f4f2",
        "storage_key": "property/6767906449166942/019d02d3-a759-7710-ad7d-5ca5dc21f4f2.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://303ramenhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13430994756007288016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "303-ramen",
      "poi_latitude": "39.80163599999999",
      "poi_longitude": "-105.082846",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-940-3866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-9fd8da389c73",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSeuUjyuGa4cR0Nzy85F6ZLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_a88346ac-ae72-4e21-af89-f714295cf08f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Hunter Bay Coffee Roasters",
      "poi_type": "Restaurants",
      "poi_address": "5600 Olde Wadsworth Blvd, Arvada, CO 80002, USA",
      "poi_short_description": "Warm, low-key operation offering daily-roasted coffee drinks, free wifi, baked goods & sandwiches.",
      "poi_long_description": "Warm, low-key operation offering daily-roasted coffee drinks, free wifi, baked goods & sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-a751-75de-bee1-1bcc1d4b6647.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-a751-75de-bee1-1bcc1d4b6647",
        "storage_key": "property/6767906449166942/019d02d3-a751-75de-bee1-1bcc1d4b6647.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hunterbay.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8280624105469818992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hunter-bay-coffee-roasters",
      "poi_latitude": "39.7992545",
      "poi_longitude": "-105.0813331",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-990-9650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2981-7743-ab99-6b35c5eeb664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2981-7743-ab99-6b35c5eeb664",
        "storage_key": "property/6767906449166942/019d02d4-2981-7743-ab99-6b35c5eeb664.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJUb4k5SyGa4cRcLgQVcCv6nI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_21627402-71f9-4f17-84dc-78da3ce88578",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "La Dolce Vita",
      "poi_type": "Restaurants",
      "poi_address": "5756 Olde Wadsworth Blvd, Arvada, CO 80002, USA",
      "poi_short_description": "Shabby-chic hangout for coffee, pastries & lunch items, plus live music & open-mike nights.",
      "poi_long_description": "Shabby-chic hangout for coffee, pastries & lunch items, plus live music & open-mike nights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-a751-75de-bee1-1f711c9d312f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-a751-75de-bee1-1f711c9d312f",
        "storage_key": "property/6767906449166942/019d02d3-a751-75de-bee1-1f711c9d312f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ldvcoffeeshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4116985765035791775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-dolce-vita",
      "poi_latitude": "39.801014",
      "poi_longitude": "-105.081272",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-456-8919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2981-7743-ab99-6b35c5eeb664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2981-7743-ab99-6b35c5eeb664",
        "storage_key": "property/6767906449166942/019d02d4-2981-7743-ab99-6b35c5eeb664.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ_YtYmyyGa4cRn1VMlr14Ijk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_7690213b-3ff2-4e18-a543-358c78f26cc0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "6408 Yank Way Suite B, Arvada, CO 80004, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-a869-77eb-ab57-9869f3f22757.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-a869-77eb-ab57-9869f3f22757",
        "storage_key": "property/6767906449166942/019d02d3-a869-77eb-ab57-9869f3f22757.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/co/arvada/6408-yank-way?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202455&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=13181183375451699488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "39.81321930000001",
      "poi_longitude": "-105.1419966",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 720-274-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2981-7743-ab99-6b35c5eeb664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2981-7743-ab99-6b35c5eeb664",
        "storage_key": "property/6767906449166942/019d02d4-2981-7743-ab99-6b35c5eeb664.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJSVWdHkSPa4cRIDkVbXH47LY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_3d2bfa91-d752-4cb7-b606-fcb56386f361",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Olde Town Tavern and Grill",
      "poi_type": "Restaurants",
      "poi_address": "7355 Ralston Rd, Arvada, CO 80002, USA",
      "poi_short_description": "Casual spot offering a wide menu of American food & a large beer list, plus pool tables & karaoke.",
      "poi_long_description": "Casual spot offering a wide menu of American food & a large beer list, plus pool tables & karaoke.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-af29-756a-9924-387d542ad200.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-af29-756a-9924-387d542ad200",
        "storage_key": "property/6767906449166942/019d02d3-af29-756a-9924-387d542ad200.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oldetowntavernandgrillarvada.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16043737539148621956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olde-town-tavern-and-grill",
      "poi_latitude": "39.8022414",
      "poi_longitude": "-105.0779574",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 720-242-9667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-9fd8da389c73",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-9fd8da389c73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiz9Nm9SHa4cRhKiN2knOpt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b705cae8-ff7f-4143-b3ee-48347f6ede3b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "King Soopers",
      "poi_type": "Shopping & Retail",
      "poi_address": "8055 Sheridan Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "Chain offering groceries, produce and pharmaceutical items, plus pickup and delivery services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-ae0a-728b-b72c-a7b901e71e5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-ae0a-728b-b72c-a7b901e71e5a",
        "storage_key": "property/6767906449166942/019d02d3-ae0a-728b-b72c-a7b901e71e5a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kingsoopers.com/stores/grocery/co/arvada/80th-and-sheridan/620/00121?cid=loc_62000121_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15958851189674697993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-soopers",
      "poi_latitude": "39.8435215",
      "poi_longitude": "-105.0565219",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 303-487-5320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-a0553dbc4689.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-a0553dbc4689",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-a0553dbc4689.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5YoJ2UmIa4cRCWXhd5o6ed0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6aa8e8b6-2b7a-4684-9f4d-3ad4f8b89194",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "8002 Chase Dr, Arvada, CO 80003, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-af5a-725a-a028-b64065442ec8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-af5a-725a-a028-b64065442ec8",
        "storage_key": "property/6767906449166942/019d02d3-af5a-725a-a028-b64065442ec8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/co/arvada/8002-chase-dr-18594?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14525410910397901118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "39.8421476",
      "poi_longitude": "-105.0570657",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 303-429-7715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-29a6-734a-8f01-4b1065fbf5d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-29a6-734a-8f01-4b1065fbf5d0",
        "storage_key": "property/6767906449166942/019d02d4-29a6-734a-8f01-4b1065fbf5d0.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJJQPgSkiIa4cRPqnZmkOglMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_e3544735-978e-4204-aead-32c73448e17a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "7584 Sheridan Blvd, Westminster, CO 80003, USA",
      "poi_short_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_long_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-afc8-746e-9ca4-8527d7df43c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-afc8-746e-9ca4-8527d7df43c9",
        "storage_key": "property/6767906449166942/019d02d3-afc8-746e-9ca4-8527d7df43c9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/westminster/7584-sheridan-blvd/2741183?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11418102846938791431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "39.8341049",
      "poi_longitude": "-105.0528249",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 303-426-1150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-29a6-734a-8f01-4b1065fbf5d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-29a6-734a-8f01-4b1065fbf5d0",
        "storage_key": "property/6767906449166942/019d02d4-29a6-734a-8f01-4b1065fbf5d0.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJe1GdID-Ia4cRB76pKAtAdZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_2b2c1783-e246-48a5-b729-3740531833dd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "7725 Wadsworth Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-b583-7388-acdf-fbcf662deceb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-b583-7388-acdf-fbcf662deceb",
        "storage_key": "property/6767906449166942/019d02d3-b583-7388-acdf-fbcf662deceb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sprouts.com/store/co/arvada/arvada",
      "poi_directions_map_url": "https://maps.google.com/?cid=14566139866323938320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "39.836654",
      "poi_longitude": "-105.083597",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-463-4828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-a0553dbc4689.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-a0553dbc4689",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-a0553dbc4689.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfM13_mIa4cREOzkoAhTJco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_008e184c-7725-4b78-a021-e4f20bae0666",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Natural Grocers",
      "poi_type": "Shopping & Retail",
      "poi_address": "7745 Wadsworth Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "Retail chain focused on natural & organic groceries, supplements & household products.",
      "poi_long_description": "Retail chain focused on natural & organic groceries, supplements & household products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-b660-7400-b0d5-809cc5cd4e87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-b660-7400-b0d5-809cc5cd4e87",
        "storage_key": "property/6767906449166942/019d02d3-b660-7400-b0d5-809cc5cd4e87.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.naturalgrocers.com/store/arvada-north-wadsworth?utm_source=googlemaps&utm_medium=local&utm_campaign=arvada-north-wadsworth",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966278550155759896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "natural-grocers",
      "poi_latitude": "39.8380198",
      "poi_longitude": "-105.0828847",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 720-403-8803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-a0553dbc4689.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-a0553dbc4689",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-a0553dbc4689.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxV4NfiIa4cRGBE9A9aebnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6e4c492e-2984-491a-9f6d-5bfa60ab1442",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "7561 W 80th Ave, Arvada, CO 80003, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-b7c6-73be-b92e-7a05b8193278.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-b7c6-73be-b92e-7a05b8193278",
        "storage_key": "property/6767906449166942/019d02d3-b7c6-73be-b92e-7a05b8193278.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.safeway.com/safeway/co/arvada/7561-w-80th-ave.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11279029534774721862&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "39.8435016",
      "poi_longitude": "-105.0807886",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-420-0318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-294d-769c-9936-a0553dbc4689.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-294d-769c-9936-a0553dbc4689",
        "storage_key": "property/6767906449166942/019d02d4-294d-769c-9936-a0553dbc4689.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3RDa_-Ia4cRRv1iX5oph5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_248c506e-5d87-405a-a162-d5f856d0ddc8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "7899 Wadsworth Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-b764-706b-a972-ecf8a4fbde73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-b764-706b-a972-ecf8a4fbde73",
        "storage_key": "property/6767906449166942/019d02d3-b764-706b-a972-ecf8a4fbde73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/arvada/48",
      "poi_directions_map_url": "https://maps.google.com/?cid=1436454023183114755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "39.8395973",
      "poi_longitude": "-105.0855167",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-425-0124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2e98-7127-988e-9025f204a114.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2e98-7127-988e-9025f204a114",
        "storage_key": "property/6767906449166942/019d02d4-2e98-7127-988e-9025f204a114.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJY9BsKv-Ia4cRA6ICzFJP7xM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_23bb88c8-6f6e-4e8a-a0ed-17fa6aefa3cf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "5195 Wadsworth Blvd #676b, Arvada, CO 80002, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-bd01-72df-b446-b0c0cf698ea9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-bd01-72df-b446-b0c0cf698ea9",
        "storage_key": "property/6767906449166942/019d02d3-bd01-72df-b446-b0c0cf698ea9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/arvada-CO-676.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=5202669117698533998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "39.78952",
      "poi_longitude": "-105.0829849",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 303-463-3603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2e98-7127-988e-9025f204a114.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2e98-7127-988e-9025f204a114",
        "storage_key": "property/6767906449166942/019d02d4-2e98-7127-988e-9025f204a114.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQXplZjSGa4cRbupQZP-XM0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_ff8a6685-b330-4b39-8120-9aeb8c84ceae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7155 Sheridan Blvd, Westminster, CO 80003, USA",
      "poi_short_description": "Wide-ranging merchandise, including clothing, electronics, and groceries, is available at this chain retailer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-bda1-7772-b066-897f92577ba9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-bda1-7772-b066-897f92577ba9",
        "storage_key": "property/6767906449166942/019d02d3-bda1-7772-b066-897f92577ba9.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3824-westminster-co/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13627216844386376452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.8252287",
      "poi_longitude": "-105.0562894",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-487-1412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2e98-7127-988e-9025f204a114.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2e98-7127-988e-9025f204a114",
        "storage_key": "property/6767906449166942/019d02d4-2e98-7127-988e-9025f204a114.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy9EpjRSIa4cRBJveFoWZHb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_70bca4f0-a627-4649-969b-e2ab9913d783",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Mesa Elementary School",
      "poi_type": "Education",
      "poi_address": "9100 Lowell Blvd, Westminster, CO 80031, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-c039-71ae-bed4-de34fc05163d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c039-71ae-bed4-de34fc05163d",
        "storage_key": "property/6767906449166942/019d02d3-c039-71ae-bed4-de34fc05163d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mesa.wps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18027873093345387448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mesa-elementary-school",
      "poi_latitude": "39.8610153",
      "poi_longitude": "-105.0337691",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-428-2891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNaTkx9eJa4cRuKOsCBDfL_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_384016cb-78f6-4c21-b74d-aad264d33351",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Shaw Heights Middle School",
      "poi_type": "Education",
      "poi_address": "8780 Circle Dr, Westminster, CO 80030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-c43a-722b-9508-7403869f6963.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c43a-722b-9508-7403869f6963",
        "storage_key": "property/6767906449166942/019d02d3-c43a-722b-9508-7403869f6963.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://shawheights.wps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16751878771958198940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shaw-heights-middle-school",
      "poi_latitude": "39.855718",
      "poi_longitude": "-105.037606",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-428-9533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmwmgcdSJa4cRnLL54vygeug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_226ea770-8e46-4f9f-98a0-507e4d0fb64c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Tennyson Knolls Preparatory School",
      "poi_type": "Education",
      "poi_address": "6330 Tennyson St, Arvada, CO 80003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-c447-7309-be5f-f37860589227.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c447-7309-be5f-f37860589227",
        "storage_key": "property/6767906449166942/019d02d3-c447-7309-be5f-f37860589227.webp",
        "width": 1280,
        "height": 759
      },
      "poi_business_url": "https://tkprep.wps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18106860579741022348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tennyson-knolls-preparatory-school",
      "poi_latitude": "39.8114816",
      "poi_longitude": "-105.0432476",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-429-4090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz8639weIa4cRjLj8VMN9SPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f6bb0ba3-c7e9-4c78-965a-17265dc5e38e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Westminster High School",
      "poi_type": "Education",
      "poi_address": "6933 N Raleigh St, Westminster, CO 80030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-c56f-704c-8b01-f1d1cb617189.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c56f-704c-8b01-f1d1cb617189",
        "storage_key": "property/6767906449166942/019d02d3-c56f-704c-8b01-f1d1cb617189.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://westy.wps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14392601301958856009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westminster-high-school",
      "poi_latitude": "39.82137549999999",
      "poi_longitude": "-105.043416",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-657-3980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK6Ll1hqIa4cRSQ0V_aDKvMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_7341008c-0a56-4b45-999c-acfa6c4e47b0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Hidden Lake Secondary School",
      "poi_type": "Education",
      "poi_address": "7300 Lowell Blvd, Westminster, CO 80030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-c7ec-73c8-addc-83762caf267b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c7ec-73c8-addc-83762caf267b",
        "storage_key": "property/6767906449166942/019d02d3-c7ec-73c8-addc-83762caf267b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hiddenlake.wps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2932374701315379472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hidden-lake-secondary-school",
      "poi_latitude": "39.8291931",
      "poi_longitude": "-105.0332183",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-428-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJayZWBR6Ia4cRENE-JEHjsSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c3bb80e2-7597-4fbc-bdb7-fc33eb532e35",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Early Learning Center at Gregory Hill",
      "poi_type": "Education",
      "poi_address": "8030 Irving St, Westminster, CO 80030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-cb78-73e6-8ff8-f7e2df9d8d61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-cb78-73e6-8ff8-f7e2df9d8d61",
        "storage_key": "property/6767906449166942/019d02d3-cb78-73e6-8ff8-f7e2df9d8d61.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://gregoryhill.wps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2424793531645465410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "early-learning-center-at-gregory-hill",
      "poi_latitude": "39.8424326",
      "poi_longitude": "-105.0291908",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 303-428-1560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ556Tydl3bIcRQpNks96YpiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_f457253c-a0d6-4699-81b1-fb411bc6cddb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Belleview Christian School",
      "poi_type": "Education",
      "poi_address": "3455 W 83rd Ave Building C, Westminster, CO 80031, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-cba3-770b-bd7b-4d111de47866.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-cba3-770b-bd7b-4d111de47866",
        "storage_key": "property/6767906449166942/019d02d3-cba3-770b-bd7b-4d111de47866.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://belleviewchristian.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17959084424675031136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleview-christian-school",
      "poi_latitude": "39.84835750000001",
      "poi_longitude": "-105.0327928",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-427-5459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCSFo4CmIa4cRYHgBCCJ8O_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9cfc8a9a-59e8-40ae-848c-594075c961c6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Colorado Preparatory Academy",
      "poi_type": "Education",
      "poi_address": "8601 Turnpike Dr #100, Westminster, CO 80031, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-cc7f-77eb-bd25-9177ad01c971.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-cc7f-77eb-bd25-9177ad01c971",
        "storage_key": "property/6767906449166942/019d02d3-cc7f-77eb-bd25-9177ad01c971.webp",
        "width": 1280,
        "height": 610
      },
      "poi_business_url": "https://cpa.k12.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13810807620531407363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-preparatory-academy",
      "poi_latitude": "39.851304",
      "poi_longitude": "-105.0508683",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 888-208-2173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB3AxJ4GJa4cRA0oIq1vYqb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a7fa9dc9-065d-4c6e-9578-7b1fcc3ad2d0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Front Range Community College - Westminster",
      "poi_type": "Education",
      "poi_address": "Wolf Central (Welcome Center, 3645 W 112th Ave Entrance 1, Westminster, CO 80031, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-cf47-761e-a892-4d0a139bb538.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-cf47-761e-a892-4d0a139bb538",
        "storage_key": "property/6767906449166942/019d02d3-cf47-761e-a892-4d0a139bb538.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.frontrange.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11260354031968358793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "front-range-community-college---westminster",
      "poi_latitude": "39.9015881",
      "poi_longitude": "-105.0374089",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-404-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpVi23wWKa4cRiZGcCFXQRJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_47c77977-d680-44e8-b294-670541b04dd6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Red Rocks Community College Arvada Campus",
      "poi_type": "Education",
      "poi_address": "10280 W 55th Ave, Arvada, CO 80002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-d277-752d-89b9-c794b34e81de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d277-752d-89b9-c794b34e81de",
        "storage_key": "property/6767906449166942/019d02d3-d277-752d-89b9-c794b34e81de.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "http://www.rrcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6425169207017463390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-rocks-community-college-arvada-campus",
      "poi_latitude": "39.7955774",
      "poi_longitude": "-105.1129738",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 303-914-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd8ZvvgSGa4cRXt4NDlrJKlk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8ff0f00c-5806-40e4-9516-9736b6975d11",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Arvada Center for the Arts and Humanities",
      "poi_type": "Entertainment",
      "poi_address": "6901 Wadsworth Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "Performance space for everything from concerts to kids' plays, plus a history museum & art gallery.",
      "poi_long_description": "Performance space for everything from concerts to kids' plays, plus a history museum & art gallery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-d292-76bd-ad4f-d6c884d17ed1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d292-76bd-ad4f-d6c884d17ed1",
        "storage_key": "property/6767906449166942/019d02d3-d292-76bd-ad4f-d6c884d17ed1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.arvadacenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12058124161517904522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arvada-center-for-the-arts-and-humanities",
      "poi_latitude": "39.823499",
      "poi_longitude": "-105.083521",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-898-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7z8mMIqIa4cRimLUyAkQV6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_e03447ee-fb78-425c-acee-da452ede10b9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Harkins Theatres Arvada 14",
      "poi_type": "Entertainment",
      "poi_address": "5550 Olde Wadsworth Blvd, Arvada, CO 80002, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-d3d2-766d-aac3-4b49b6d6da9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d3d2-766d-aac3-4b49b6d6da9a",
        "storage_key": "property/6767906449166942/019d02d3-d3d2-766d-aac3-4b49b6d6da9a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.harkins.com/locations/arvada-14?utm_source=google&utm_medium=local&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=836957718448201534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harkins-theatres-arvada-14",
      "poi_latitude": "39.7977626",
      "poi_longitude": "-105.080153",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 720-791-5550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34bc-75b8-90c3-1addc808d56d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34bc-75b8-90c3-1addc808d56d",
        "storage_key": "property/6767906449166942/019d02d4-34bc-75b8-90c3-1addc808d56d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6pqPi2Ga4cRPl8gTJx4nQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_1902ab0a-a48d-4cca-8d95-9f64f2118ad2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Olde Town Arvada",
      "poi_type": "Entertainment",
      "poi_address": "Olde Town Arvada, Arvada, CO 80002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-d68a-73b3-a3e6-5cbe2f592480.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d68a-73b3-a3e6-5cbe2f592480",
        "storage_key": "property/6767906449166942/019d02d3-d68a-73b3-a3e6-5cbe2f592480.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10258257799881878224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olde-town-arvada",
      "poi_latitude": "39.8008742",
      "poi_longitude": "-105.0798535",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAebUNCuGa4cR0OpWUB6nXI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3232af63-e02c-493b-8048-ffb3fe85cf0b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Arvada Flour Mill Museum",
      "poi_type": "Entertainment",
      "poi_address": "5590 Olde Wadsworth Blvd, Arvada, CO 80002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18137091333723394561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arvada-flour-mill-museum",
      "poi_latitude": "39.7996828",
      "poi_longitude": "-105.0814762",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-431-1261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2OD8SyGa4cRARJmPXnks_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_f5eda5e5-1729-45a3-b0ce-ed680b776b52",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Cussler Museum",
      "poi_type": "Entertainment",
      "poi_address": "14959 W 69th Ave, Arvada, CO 80007, USA",
      "poi_short_description": "Seasonal destination for an author's collection of classic vehicles dating from 1909 to the 1960s.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-d9ab-76de-b634-c955056d7a90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d9ab-76de-b634-c955056d7a90",
        "storage_key": "property/6767906449166942/019d02d3-d9ab-76de-b634-c955056d7a90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cusslermuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16081048955126373066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cussler-museum",
      "poi_latitude": "39.8231013",
      "poi_longitude": "-105.167748",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 303-420-2795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34c7-7609-8cdf-511ab5815f3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34c7-7609-8cdf-511ab5815f3e",
        "storage_key": "property/6767906449166942/019d02d4-34c7-7609-8cdf-511ab5815f3e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJNeHC2giPa4cRylr52dJcK98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_520ab7c5-f43c-4c65-9bab-a553b533c8fb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Odyssey Beerwerks Brewery & Taproom",
      "poi_type": "Entertainment",
      "poi_address": "5535 W 56th Ave #107, Arvada, CO 80002, USA",
      "poi_short_description": "Convivial taproom & brewery featuring flagship & specialty draft beers, plus a patio.",
      "poi_long_description": "Convivial taproom & brewery featuring flagship & specialty draft beers, plus a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-e247-707d-aeb3-51161d087c8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-e247-707d-aeb3-51161d087c8f",
        "storage_key": "property/6767906449166942/019d02d3-e247-707d-aeb3-51161d087c8f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.odysseybeerwerks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8462283987652923625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "odyssey-beerwerks-brewery--taproom",
      "poi_latitude": "39.8006973",
      "poi_longitude": "-105.058876",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-421-0772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm40EpcKHa4cR6VCHoHMScHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food"
    },
    {
      "id": "custom_11b9503c-d18f-42fb-91bd-b3efc27890ad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Lakeside Amusement Park",
      "poi_type": "Entertainment",
      "poi_address": "4601 Sheridan Blvd, Denver, CO 80212, USA",
      "poi_short_description": "Circa-1908 fun park that's a time warp to the past with wooden roller coasters, funnel cakes & more.",
      "poi_long_description": "Circa-1908 fun park that's a time warp to the past with wooden roller coasters, funnel cakes & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-e1b8-76e8-b829-5c156e552717.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-e1b8-76e8-b829-5c156e552717",
        "storage_key": "property/6767906449166942/019d02d3-e1b8-76e8-b829-5c156e552717.webp",
        "width": 1024,
        "height": 672
      },
      "poi_business_url": "http://www.lakesideamusementpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2731565663136255498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakeside-amusement-park",
      "poi_latitude": "39.7791698",
      "poi_longitude": "-105.0540747",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-477-1621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuZkeRJiHa4cRCg7kh3946CU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_2c69c653-af2f-46b1-af17-ceef9cdb17f3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "North Suburban Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9191 Grant St, Thornton, CO 80229, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://healthoneems.com/about/directory/nsmc.dot",
      "poi_directions_map_url": "https://maps.google.com/?cid=17761269876135540644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-suburban-medical-center",
      "poi_latitude": "39.8635551",
      "poi_longitude": "-104.9857089",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 303-451-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34fe-75ca-b7d1-1f3a316aab51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34fe-75ca-b7d1-1f3a316aab51",
        "storage_key": "property/6767906449166942/019d02d4-34fe-75ca-b7d1-1f3a316aab51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8fA3eAB3bIcRpLfnXtm0fPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_13033079-6425-4089-a646-9a53e88677e6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "UCHealth Broomfield Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "11820 Destination Dr, Broomfield, CO 80021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-e363-75b0-94f2-18cdf091d8c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-e363-75b0-94f2-18cdf091d8c5",
        "storage_key": "property/6767906449166942/019d02d3-e363-75b0-94f2-18cdf091d8c5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-broomfield-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7782162309731185344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uchealth-broomfield-hospital",
      "poi_latitude": "39.9104107",
      "poi_longitude": "-105.091616",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-464-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34fe-75ca-b7d1-1f3a316aab51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34fe-75ca-b7d1-1f3a316aab51",
        "storage_key": "property/6767906449166942/019d02d4-34fe-75ca-b7d1-1f3a316aab51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIysa-rmLa4cRwPL1l2PL_2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9e61634f-063d-4a87-8f03-bdb56fb144ec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "AFC Urgent Care Arvada",
      "poi_type": "Health and Wellness",
      "poi_address": "6335 Sheridan Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-e5e0-76da-922f-00b1eee02e1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-e5e0-76da-922f-00b1eee02e1d",
        "storage_key": "property/6767906449166942/019d02d3-e5e0-76da-922f-00b1eee02e1d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.afcurgentcare.com/arvada/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-arvada-gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14880150616025445193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-arvada",
      "poi_latitude": "39.8112512",
      "poi_longitude": "-105.0540519",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 720-502-0466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcZQB5guJa4cRSbOBmCXqgM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_e32f6398-997c-404b-8eeb-b65bd06f3183",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "King Soopers Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8055 Sheridan Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-e862-7058-ae24-b191c204f595.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-e862-7058-ae24-b191c204f595",
        "storage_key": "property/6767906449166942/019d02d3-e862-7058-ae24-b191c204f595.webp",
        "width": 1044,
        "height": 587
      },
      "poi_business_url": "https://www.kingsoopers.com/rx/pharmacy/details/620/00121?cid=loc_62000121P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9239931841888663290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-soopers-pharmacy",
      "poi_latitude": "39.8435052",
      "poi_longitude": "-105.0564381",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 303-487-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2e9a-70cd-86b5-227235785c95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2e9a-70cd-86b5-227235785c95",
        "storage_key": "property/6767906449166942/019d02d4-2e9a-70cd-86b5-227235785c95.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZA_3EmIa4cR-jaYEA7VOoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_40123e48-1712-4589-9595-bab294e77711",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7899 Wadsworth Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-be5a-749f-b814-bba85d7e6324.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-be5a-749f-b814-bba85d7e6324",
        "storage_key": "property/6767906449166942/019d02d3-be5a-749f-b814-bba85d7e6324.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://www.cvs.com/store-locator/arvada-co-pharmacies/7899-wadsworth-blvd-arvada-co-80003/storeid=16009?WT.mc_id=LS_GOOGLE_RX_16009",
      "poi_directions_map_url": "https://maps.google.com/?cid=1730513984290767426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.8395973",
      "poi_longitude": "-105.0855167",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-425-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2e9a-70cd-86b5-227235785c95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2e9a-70cd-86b5-227235785c95",
        "storage_key": "property/6767906449166942/019d02d4-2e9a-70cd-86b5-227235785c95.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9BsKv-Ia4cRQkJ_0EwFBBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a727b41f-c097-4d04-aa47-d227359cb5b4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8105 Sheridan Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-e95f-72c2-af24-e804189e684a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-e95f-72c2-af24-e804189e684a",
        "storage_key": "property/6767906449166942/019d02d3-e95f-72c2-af24-e804189e684a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/arvada-co/arvada-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=8264849471828020688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "39.8444299",
      "poi_longitude": "-105.0553169",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 303-426-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf3NFZzaIa4cR0E1iOs6ksnI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_06a323c8-5d48-4eae-a96e-73d998aa2fac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6520 Wadsworth Blvd Ste 130, Arvada, CO 80003, USA",
      "poi_short_description": "Chain fitness center featuring cardio machines, free weights, and functional training areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-eb2e-7669-9821-3f09090af0d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-eb2e-7669-9821-3f09090af0d3",
        "storage_key": "property/6767906449166942/019d02d3-eb2e-7669-9821-3f09090af0d3.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/arvada-colorado-2069/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=2069",
      "poi_directions_map_url": "https://maps.google.com/?cid=889870908318435919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "39.8150122",
      "poi_longitude": "-105.0801506",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-456-6667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWDtUxCGa4cRT0pGWuB0WQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_54ed986d-c84b-4b0b-bab1-6a3db4ffb64f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8031 Wadsworth Blvd A2, Arvada, CO 80003, USA",
      "poi_short_description": "Fitness studio, part of a chain, that combines cardio and strength exercises in group classes, with a focus on heart-rate training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-ed93-7002-a2d1-52e59c016516.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-ed93-7002-a2d1-52e59c016516",
        "storage_key": "property/6767906449166942/019d02d3-ed93-7002-a2d1-52e59c016516.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/arvada-colorado-0561?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=9965630974798207292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "39.8425567",
      "poi_longitude": "-105.0837578",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-647-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_vX8v6Ia4cRPBl6R5IITYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_52900de9-c1cc-4d06-8544-d04df787b3f9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "7705 Wadsworth Blvd Suite 13, Arvada, CO 80003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-ef9a-7529-a40a-ce6a35e83790.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-ef9a-7529-a40a-ce6a35e83790",
        "storage_key": "property/6767906449166942/019d02d3-ef9a-7529-a40a-ce6a35e83790.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.clubpilates.com/arvada/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=9997405209051151699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "39.8361413",
      "poi_longitude": "-105.0837747",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-650-4044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN1FYhEKJa4cRUz0isRHrvYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_11ef6d9c-3674-4828-b14e-3236fe37a2af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Arvada Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "8330 W 80th Ave #2, Arvada, CO 80005, USA",
      "poi_short_description": "Gym, barre studio and community offering fitness classes for all levels, plus instruction and encouragement.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-f197-7798-8993-b4f746795e75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-f197-7798-8993-b4f746795e75",
        "storage_key": "property/6767906449166942/019d02d3-f197-7798-8993-b4f746795e75.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.arvadabarre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8818074554679558145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arvada-barre",
      "poi_latitude": "39.84080549999999",
      "poi_longitude": "-105.0908462",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-880-6447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ed3-7418-8a70-2dc3e72ae7de",
        "storage_key": "property/6767906449166942/019d02d4-2ed3-7418-8a70-2dc3e72ae7de.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl9sPq_yIa4cRAQCWWhYYYHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_38bef6eb-defb-4b89-b425-8155b16e6671",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Lake Arbor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6450 Pomona Dr, Arvada, CO 80003, USA",
      "poi_short_description": "Venue featuring a kids' playground, open fields & multiple trails, including a loop around the lake.",
      "poi_long_description": "Venue featuring a kids' playground, open fields & multiple trails, including a loop around the lake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-f3e3-7519-870e-5a3f6dbdd67d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-f3e3-7519-870e-5a3f6dbdd67d",
        "storage_key": "property/6767906449166942/019d02d3-f3e3-7519-870e-5a3f6dbdd67d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://arvadaco.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=15269641055350506182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-arbor-park",
      "poi_latitude": "39.8450807",
      "poi_longitude": "-105.0683604",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 720-898-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34bb-7119-9477-9078d4cb720e",
        "storage_key": "property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoylcClKIa4cRxkLjR6Op6NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_43168a6f-c751-4d5d-83f5-b0917c2d5227",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Memorial Park and Johnny Roberts Disc Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8001 W 59th Ave, Arvada, CO 80004, USA",
      "poi_short_description": "Park featuring a short par 3 disc golf course with water features.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-f634-7341-b100-7913971bf515.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-f634-7341-b100-7913971bf515",
        "storage_key": "property/6767906449166942/019d02d3-f634-7341-b100-7913971bf515.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://arvada.org/explore/sports-recreation/disc-golf",
      "poi_directions_map_url": "https://maps.google.com/?cid=13218925278852772025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-park-and-johnny-roberts-disc-golf-course",
      "poi_latitude": "39.8041734",
      "poi_longitude": "-105.0856214",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 720-898-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTVoMjimGa4cRuXBzFoEOc7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_493a0d88-7dbf-40f8-b16a-2328b0b64bae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Ralston Central Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5850 Garrison St, Arvada, CO 80002, USA",
      "poi_short_description": "Big, vibrant park with grassy areas & paved trails, plus picnic shelters, a splash pad & playground.",
      "poi_long_description": "Big, vibrant park with grassy areas & paved trails, plus picnic shelters, a splash pad & playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-f813-7505-a20d-5a7fcce08339.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-f813-7505-a20d-5a7fcce08339",
        "storage_key": "property/6767906449166942/019d02d3-f813-7505-a20d-5a7fcce08339.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://arvada.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10724996504266603773&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ralston-central-park",
      "poi_latitude": "39.8028033",
      "poi_longitude": "-105.0981567",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 720-898-7410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34bb-7119-9477-9078d4cb720e",
        "storage_key": "property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSWM2iKGa4cR_fwdRn_X1pQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5705e5d6-6dc3-4bd4-a0bc-961dc75e2281",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Gold Strike Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5500 W 56th Ave, Arvada, CO 80002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5545804389597131825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gold-strike-park",
      "poi_latitude": "39.7980399",
      "poi_longitude": "-105.0561068",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34bb-7119-9477-9078d4cb720e",
        "storage_key": "property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVmcKHa4cRMTS9m7Wn9kw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4294231d-262a-47fa-ac01-843aab6aacfc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Two Ponds National Wildlife Refuge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9210 W 80th Ave, Arvada, CO 80005, USA",
      "poi_short_description": "Animal refuge set on uplands & wetlands & designed to protect birds, deer, turtles & native flora.",
      "poi_long_description": "Animal refuge set on uplands & wetlands & designed to protect birds, deer, turtles & native flora.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-db94-7071-a691-18415dc1469c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-db94-7071-a691-18415dc1469c",
        "storage_key": "property/6767906449166942/019d02d3-db94-7071-a691-18415dc1469c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fws.gov/refuge/two-ponds",
      "poi_directions_map_url": "https://maps.google.com/?cid=3187995689142575183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "two-ponds-national-wildlife-refuge",
      "poi_latitude": "39.8396119",
      "poi_longitude": "-105.1039",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-289-0867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34bb-7119-9477-9078d4cb720e",
        "storage_key": "property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkYfmYd6Ia4cRT-DRRDAJPiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_a04c8b66-4248-4bd7-9225-a5c62e1f215b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Butterfly Pavilion",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6252 W 104th Ave, Westminster, CO 80020, USA",
      "poi_short_description": "This conservatory known for its 1500+ butterflies is home to invertebrates from both land & sea.",
      "poi_long_description": "This conservatory known for its 1500+ butterflies is home to invertebrates from both land & sea.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-fcf0-720d-8b73-1a4044ee9b90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-fcf0-720d-8b73-1a4044ee9b90",
        "storage_key": "property/6767906449166942/019d02d3-fcf0-720d-8b73-1a4044ee9b90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.butterflies.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10460704098384178030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "butterfly-pavilion",
      "poi_latitude": "39.8873108",
      "poi_longitude": "-105.0666409",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-469-5441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ34zTb4iJa4cRbmupTPTiK5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_088b91af-2b27-4d85-b984-3a72a3e3a2ae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Blunn Reservoir",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Blunn Reservoir, Arvada, CO, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-fd60-752f-bb3d-5f3a1c50ea3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-fd60-752f-bb3d-5f3a1c50ea3e",
        "storage_key": "property/6767906449166942/019d02d3-fd60-752f-bb3d-5f3a1c50ea3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8254497048165197319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blunn-reservoir",
      "poi_latitude": "39.8232795",
      "poi_longitude": "-105.2092423",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRrMatGPa4cRB6Zlw1TdjXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "natural_feature"
    },
    {
      "id": "custom_dd8eb66a-c30e-4267-85f0-3d7483b65193",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "West Arvada Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17975 W 64th Pkwy, Arvada, CO 80002, USA",
      "poi_short_description": "Dog park featuring large, open areas as well as enclosures for smaller or shy dogs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-01b3-741f-8b97-3f93b8e539ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-01b3-741f-8b97-3f93b8e539ee",
        "storage_key": "property/6767906449166942/019d02d4-01b3-741f-8b97-3f93b8e539ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://arvada.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7010207663405263384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-arvada-dog-park",
      "poi_latitude": "39.8174343",
      "poi_longitude": "-105.2057967",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34bb-7119-9477-9078d4cb720e",
        "storage_key": "property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8APTMSPa4cRGOr9arpCSWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_f01f428f-644b-4340-bd8a-eeff700b874b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Long Lake Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17850 W 64th Ave, Arvada, CO 80403, USA",
      "poi_short_description": "Community park featuring an athletic complex with baseball & soccer fields, plus a concession stand.",
      "poi_long_description": "Community park featuring an athletic complex with baseball & soccer fields, plus a concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-032f-7025-a562-d5aa279b4877.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-032f-7025-a562-d5aa279b4877",
        "storage_key": "property/6767906449166942/019d02d4-032f-7025-a562-d5aa279b4877.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.arvadaco.gov/649/Sports-Complex-Permitting-Scheduling",
      "poi_directions_map_url": "https://maps.google.com/?cid=335442501638025190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "long-lake-regional-park",
      "poi_latitude": "39.81130539999999",
      "poi_longitude": "-105.2104424",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 720-898-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34bb-7119-9477-9078d4cb720e",
        "storage_key": "property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoy7jJ-aPa4cR5u-zkC27pwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1a2787eb-4bd2-4f6a-806c-133f2e276a2b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Majestic View Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7030 Garrison St, Arvada, CO 80004, USA",
      "poi_short_description": "Kid-friendly park with a nature center featuring exhibits for kids, plus trails with wildlife.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-d9bf-7151-8705-6e42bdced906.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d9bf-7151-8705-6e42bdced906",
        "storage_key": "property/6767906449166942/019d02d3-d9bf-7151-8705-6e42bdced906.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://majesticviewnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4072708854993267852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "majestic-view-nature-center",
      "poi_latitude": "39.824104",
      "poi_longitude": "-105.0995503",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 720-898-7405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34bb-7119-9477-9078d4cb720e",
        "storage_key": "property/6767906449166942/019d02d4-34bb-7119-9477-9078d4cb720e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJswvEMpWIa4cRjCx2HyArhTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_27ff320d-6cff-4dce-a553-c6d45c06a62b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "60th/Sheridan-Arvada Gold Strike Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "5980 Sheridan Blvd, Arvada, CO 80003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-05ea-71bc-afee-d947d0fa6b09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-05ea-71bc-afee-d947d0fa6b09",
        "storage_key": "property/6767906449166942/019d02d4-05ea-71bc-afee-d947d0fa6b09.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.rtd-denver.com/60thsheridan-arvada-gold-strike-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=17045260904178757492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "60thsheridan-arvada-gold-strike-station",
      "poi_latitude": "39.8037668",
      "poi_longitude": "-105.0490477",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-3a34-72dd-85b2-7e75a83a1c18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3a34-72dd-85b2-7e75a83a1c18",
        "storage_key": "property/6767906449166942/019d02d4-3a34-72dd-85b2-7e75a83a1c18.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJD5PpF-SHa4cRdK9tkXvujOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_f17abec2-0483-476c-958f-4c06948385ea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Arvada Ridge Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Arvada, CO 80033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-09db-7541-ac8d-c5417ef3cce9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-09db-7541-ac8d-c5417ef3cce9",
        "storage_key": "property/6767906449166942/019d02d4-09db-7541-ac8d-c5417ef3cce9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rtd-denver.com/arvada-ridge-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1262704860715559726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arvada-ridge-station",
      "poi_latitude": "39.7925264",
      "poi_longitude": "-105.1116232",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8GwhhCGa4cRLiscd2EHhhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_b4bcead8-b30e-4842-ae0c-4a258dd7a975",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Wheat Ridge / Ward Road Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "12000 Ridge Rd, Wheat Ridge, CO 80033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-0e89-766b-87c8-e237a9f391cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0e89-766b-87c8-e237a9f391cd",
        "storage_key": "property/6767906449166942/019d02d4-0e89-766b-87c8-e237a9f391cd.webp",
        "width": 640,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15683138258047775616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wheat-ridge--ward-road-station",
      "poi_latitude": "39.7879767",
      "poi_longitude": "-105.133117",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-3a34-72dd-85b2-7e75a83a1c18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3a34-72dd-85b2-7e75a83a1c18",
        "storage_key": "property/6767906449166942/019d02d4-3a34-72dd-85b2-7e75a83a1c18.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJY86dNfuFa4cRgLNGIiezpdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_9a7f61b8-955c-4ca9-af69-e1acb408abe2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "US 36 and Sheridan Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "5025 W 88th Pl, Westminster, CO 80003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-0f6b-72fd-9076-c848cf944cdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0f6b-72fd-9076-c848cf944cdc",
        "storage_key": "property/6767906449166942/019d02d4-0f6b-72fd-9076-c848cf944cdc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6139829446612038410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-36-and-sheridan-station",
      "poi_latitude": "39.8576106",
      "poi_longitude": "-105.0524175",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-3a55-772b-850c-8aa77b430dc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3a55-772b-850c-8aa77b430dc4",
        "storage_key": "property/6767906449166942/019d02d4-3a55-772b-850c-8aa77b430dc4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJby3s4siJa4cRCjPL-lkONVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_0f9c68bc-120b-4a4d-b39e-cf396c6fab8c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Westminster Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "6995 Grove St, Westminster, CO 80030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-1118-766a-a001-647a0d9a69a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-1118-766a-a001-647a0d9a69a2",
        "storage_key": "property/6767906449166942/019d02d4-1118-766a-a001-647a0d9a69a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rtd-denver.com/b-line-stations.shtml#westminster-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1304441266296738124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westminster-station",
      "poi_latitude": "39.8227175",
      "poi_longitude": "-105.0292118",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQc2uzeJ3bIcRTFH6o2tOGhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_4f0a9af6-0751-4892-9fe3-38da41af2a78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Denver International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8500 Peña Blvd, Denver, CO 80249, USA",
      "poi_short_description": "Sprawling, 54-sq.-mile facility known for a tentlike roof meant to resemble snow-capped mountains.",
      "poi_long_description": "Sprawling, 54-sq.-mile facility known for a tentlike roof meant to resemble snow-capped mountains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-129b-717c-907f-183cb2c08e32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-129b-717c-907f-183cb2c08e32",
        "storage_key": "property/6767906449166942/019d02d4-129b-717c-907f-183cb2c08e32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flydenver.com/?utm_source=google&utm_medium=organic&utm_campaign=GBP",
      "poi_directions_map_url": "https://maps.google.com/?cid=5285039807900523626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denver-international-airport",
      "poi_latitude": "39.8563486",
      "poi_longitude": "-104.6764061",
      "poi_miles_from_property": "24",
      "poi_walking_minutes": "8 hours 47 mins",
      "poi_biking_minutes": "2 hours 21 mins",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "+1 720-730-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-3a62-77de-bd7e-7a995b3099ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3a62-77de-bd7e-7a995b3099ed",
        "storage_key": "property/6767906449166942/019d02d4-3a62-77de-bd7e-7a995b3099ed.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0T_mCp_bIcRapy1NbQ7WEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_096f57c7-7c3d-4b1e-ac24-ab54ed2c88f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Intermountain Health Lutheran Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12911 W 40th Ave, Wheat Ridge, CO 80401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-169e-7204-82dd-7e2969a3c273.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-169e-7204-82dd-7e2969a3c273",
        "storage_key": "property/6767906449166942/019d02d4-169e-7204-82dd-7e2969a3c273.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://intermountainhealthcare.org/locations/intermountain-health-lutheran-hospital?utm_campaign=gmb&utm_medium=organic&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6800742308767420355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intermountain-health-lutheran-hospital",
      "poi_latitude": "39.7718374",
      "poi_longitude": "-105.1454666",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 303-425-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34fe-75ca-b7d1-1f3a316aab51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34fe-75ca-b7d1-1f3a316aab51",
        "storage_key": "property/6767906449166942/019d02d4-34fe-75ca-b7d1-1f3a316aab51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJOelLQ1eGa4cRw08NExkXYV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c6458090-4a80-4aeb-abb1-caa21a49c1e1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "CommonSpirit St. Anthony North Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14300 Orchard Pkwy, Westminster, CO 80023, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-182f-73bb-b7a5-2a3c7ef3d7d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-182f-73bb-b7a5-2a3c7ef3d7d6",
        "storage_key": "property/6767906449166942/019d02d4-182f-73bb-b7a5-2a3c7ef3d7d6.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/st-anthony-north-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=825369710359015077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonspirit-st-anthony-north-hospital",
      "poi_latitude": "39.95573539999999",
      "poi_longitude": "-104.9913554",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 720-627-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-34fe-75ca-b7d1-1f3a316aab51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-34fe-75ca-b7d1-1f3a316aab51",
        "storage_key": "property/6767906449166942/019d02d4-34fe-75ca-b7d1-1f3a316aab51.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYBO1B51bIcRpe5Q6mBNdAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1e4c0602-c95a-4df8-8dcf-8ff19a391010",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Arvada City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8101 Ralston Rd, Arvada, CO 80002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-18e2-706b-acba-3e15b5b66929.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-18e2-706b-acba-3e15b5b66929",
        "storage_key": "property/6767906449166942/019d02d4-18e2-706b-acba-3e15b5b66929.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.arvadaco.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8869725798779029513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arvada-city-hall",
      "poi_latitude": "39.8029665",
      "poi_longitude": "-105.0879059",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 720-898-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-3b50-7596-9463-1a9a3d652191.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3b50-7596-9463-1a9a3d652191",
        "storage_key": "property/6767906449166942/019d02d4-3b50-7596-9463-1a9a3d652191.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVZ1Su2Ha4cRCYhXw56YF3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_a740afb0-dfaf-486b-b259-64eae3d88e15",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Honeywell Sundyne",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14845 W 64th Ave #7523, Arvada, CO 80007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-1ac6-7374-a9ca-c299e74c2b01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-1ac6-7374-a9ca-c299e74c2b01",
        "storage_key": "property/6767906449166942/019d02d4-1ac6-7374-a9ca-c299e74c2b01.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sundyne.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6964303145100430103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honeywell-sundyne",
      "poi_latitude": "39.8140236",
      "poi_longitude": "-105.1689265",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 303-425-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlYk5v3SPa4cRF8vY388spmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_324296f0-7073-4c4b-96d7-fb3e83d56629",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Barber-Nichols",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6350 W 56th Ave, Arvada, CO 80002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-1f2a-76e8-8a10-4813fa8cc22a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-1f2a-76e8-8a10-4813fa8cc22a",
        "storage_key": "property/6767906449166942/019d02d4-1f2a-76e8-8a10-4813fa8cc22a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://barber-nichols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17408856825786624897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barber-nichols",
      "poi_latitude": "39.7973268",
      "poi_longitude": "-105.0670616",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-421-8111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9x_ZZcWHa4cRgWulBgyvmPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4a7e89e3-352c-4b95-9c22-737b84289c1b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Mark VII Equipment Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5981 Tennyson St, Arvada, CO 80003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2081-737c-a27e-4adf61f7dd09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-2081-737c-a27e-4adf61f7dd09",
        "storage_key": "property/6767906449166942/019d02d4-2081-737c-a27e-4adf61f7dd09.webp",
        "width": 1080,
        "height": 866
      },
      "poi_business_url": "http://www.markvii.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12360757514903829037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mark-vii-equipment-inc",
      "poi_latitude": "39.8050214",
      "poi_longitude": "-105.0450155",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-423-4910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD5T9uOSHa4cRLTqVPng7iqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_wash"
    },
    {
      "id": "custom_098018da-1333-4e8b-8343-8795b202b64d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Wanco Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5870 Tennyson St, Arvada, CO 80003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-213d-71cb-88a4-bd729675f168.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-213d-71cb-88a4-bd729675f168",
        "storage_key": "property/6767906449166942/019d02d4-213d-71cb-88a4-bd729675f168.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wanco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=238362254163101616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wanco-inc",
      "poi_latitude": "39.8037015",
      "poi_longitude": "-105.042944",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-427-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-2ecd-72f5-8c15-3b2f11c76a65",
        "storage_key": "property/6767906449166942/019d02d4-2ecd-72f5-8c15-3b2f11c76a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2dPQ3vqHa4cRsMdADzXVTgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f1e7e6d3-4f18-4861-a4ec-c7359e51e027",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "custom",
      "poi_name": "Jefferson County Motor Vehicle",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6510 Wadsworth Blvd UNIT 320, Arvada, CO 80003, USA",
      "poi_short_description": "Friendly and efficient office for motor vehicle registrations, title transfers and new plates.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-2228-76fb-94b6-cef53a1421e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-2228-76fb-94b6-cef53a1421e6",
        "storage_key": "property/6767906449166942/019d02d4-2228-76fb-94b6-cef53a1421e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jeffco.us/397/Motor-Vehicle",
      "poi_directions_map_url": "https://maps.google.com/?cid=13063072473933330484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-county-motor-vehicle",
      "poi_latitude": "39.8147125",
      "poi_longitude": "-105.0791611",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-271-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d4-3b50-7596-9463-1a9a3d652191.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3b50-7596-9463-1a9a3d652191",
        "storage_key": "property/6767906449166942/019d02d4-3b50-7596-9463-1a9a3d652191.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4YVqvoeIa4cRNLj6MzRbSbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_c8fed1df-58fe-4548-b89b-5bb28775a121",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_fc10af60-cb02-4ae2-98be-0c698bd33d83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_a65a2dc7-0a52-4c56-8038-f6c58b5ab946",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_be9439b4-4938-499f-a257-f9f89f62a6a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_270da280-b975-4aa6-9654-c39d6c91c9f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_d0c868cb-aead-44cc-ac18-1af1e3a6a62c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e9013c17-e36b-4a29-a101-60c887d47c95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "rating": "5.0",
      "name": "Charlene Beiler",
      "text": "The new management team is truly amazing, and are going above and beyond in their work here! They are efficient, professional, and just genuinely dedicated to making this a wonderful place to live! They listen and truly want us to be comfortable here! The turnaround has been nothing short of incredible and miraculous, and in the 5 years I've been here, this is the only time I'd ever highly recommend this complex to anyone looking for a well-managed apartment home to live.\n\nA extremely special thanks to property manager Johnika, front desk Kathy, and maintenance supervisor Austin- you all have been absolutely amazing in helping me. Thank you for all you do!!!",
      "date": "2026-04-21",
      "title": ""
    },
    {
      "id": "custom_0ffea38b-7210-4298-b3b0-4fba3b74492a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "rating": "4.0",
      "name": "Kathleena B",
      "text": "Fixed  my sister's ac and did there job as soon as the office was open! Thank you maintenance  fir doing your job and help fix the stuff needs to be fixed and thank you kathy for always helping  out when needed!",
      "date": "2026-06-01",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019b0964-e7f4-7762-8dca-4d69b7cdae1a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-toscana-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-arvada-co",
      "search_query": "pet friendly apartments Arvada CO",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Arvada, CO",
      "h2_subtitle": "Explore pet friendly apartments in Arvada, CO at Toscana. Our welcoming community offers amenities perfect for pet lovers and their furry friends.",
      "page_copy": "Discover Toscana Apartments, where pet-friendly living in Arvada, CO is truly embraced. Our community is designed with your pets in mind, featuring a comfortable dog park that encourages bonding and exercise with your four-legged friend. \n\nToscana Apartments offers stylish studio, one, and two-bedroom floor plans that cater to modern living. Enjoy amenities like a refreshing pool and a business center, perfect for balancing work and leisure. Visit us to experience why our community is ideal for you and your pets!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Arvada, CO",
      "seo_description": "Experience pet friendly living at Toscana Apartments in Arvada, CO, with amenities like a dog park, perfect for you and your furry friend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "apartments-with-pool-south-westminster",
      "search_query": "apartments with pool in South Westminster",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in South Westminster",
      "h2_subtitle": "Enjoy modern living at Toscana Apartments featuring a pool in South Westminster. Discover our communal amenities designed for relaxation and fun.",
      "page_copy": "At Toscana Apartments in South Westminster, our community provides an inviting oasis with a stunning pool for residents to unwind and enjoy. Whether you're looking for a studio, one, or two-bedroom apartment, our spaces offer comfort and style.\n\nTake advantage of our additional amenities like the pet-friendly dog park and our welcoming clubhouse. In the heart of Arvada, CO, Toscana connects you with the vibrant energy of South Westminster, making it an ideal choice for those seeking a dynamic lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in South Westminster",
      "seo_description": "Find your next home at Toscana Apartments in South Westminster, featuring a pool and modern amenities for relaxed living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "toscana-apartments-dog-park-80003",
      "search_query": "Toscana Apartments with dog park 80003",
      "category": "Amenity",
      "h1_title": "Explore Toscana Apartments with Dog Park",
      "h2_subtitle": "Toscana Apartments in 80003 features a welcoming dog park. Discover our pet-friendly community designed for you and your furry friends.",
      "page_copy": "Located in the vibrant community of Arvada, CO, Toscana Apartments offers a unique living experience with a dedicated dog park right within the complex. Our residents and their pets enjoy this fantastic amenity that promotes outdoor fun and exercise.\n\nChoose from stylish studio, one, or two-bedroom floor plans, each designed to provide a comfortable and contemporary living space. Enjoy our additional amenities, such as a refreshing pool and a cozy clubhouse, making Toscana Apartments a perfect home for pet lovers in the 80003 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Toscana Apartments with Dog Park in 80003",
      "seo_description": "Discover Toscana Apartments in 80003, with a dedicated dog park. Enjoy pet-friendly living with modern amenities in Arvada, CO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-adams-county",
      "search_query": "air conditioned apartments in Adams County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Adams County",
      "h2_subtitle": "Stay comfortable at Toscana Apartments in Adams County. Enjoy air-conditioned living spaces along with a variety of modern amenities.",
      "page_copy": "Experience unparalleled comfort at Toscana Apartments, located in scenic Adams County. Our air-conditioned apartments ensure a pleasant environment year-round, making them an ideal choice for those who value comfort and style.\n\nOur community offers a range of amenities, including a refreshing pool and a business center, alongside stylish studio, one, and two-bedroom options. Featuring a welcoming atmosphere, Toscana Apartments is perfect for anyone seeking a modern living experience in Adams County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Adams County",
      "seo_description": "Discover air-conditioned living at Toscana Apartments in Adams County. Enjoy comfortable spaces with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-sheridan-boulevard",
      "search_query": "apartments with dishwasher near Sheridan Boulevard",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher Near Sheridan Blvd",
      "h2_subtitle": "Find modern homes featuring dishwashers close to Sheridan Boulevard at Toscana Apartments. Enjoy contemporary living with convenient amenities.",
      "page_copy": "Toscana Apartments, situated near Sheridan Boulevard in Arvada, CO, offers an ideal blend of convenience and comfort. Our apartments come equipped with modern amenities, including a dishwasher, ensuring ease and efficiency in your daily routine.\n\nChoose from our selection of studio, one, or two-bedroom layouts designed to fit your lifestyle. Enjoy additional features like a sparkling pool and a community clubhouse, making Toscana Apartments a top choice for convenient living near Sheridan Boulevard.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher Near Sheridan Blvd",
      "seo_description": "Toscana Apartments near Sheridan Blvd offer homes with dishwashers. Enjoy modern living in Arvada with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "studio-apartments-south-westminster",
      "search_query": "studio apartments south westminster",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in South Westminster",
      "h2_subtitle": "Discover comfortable studio apartments at Toscana Apartments. Located in South Westminster, these homes offer modern amenities and a vibrant community.",
      "page_copy": "Nestled in the heart of South Westminster, Toscana Apartments offers studio apartments that blend style and comfort. Perfectly designed for modern living, these units provide a cozy yet spacious environment.\n\nResidents here enjoy a fantastic range of amenities, including a lounge, business center, and refreshing pool. With this vibrant community atmosphere, Toscana Apartments stands as an ideal choice for those looking to live in South Westminster.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in South Westminster",
      "seo_description": "Find stylish studio apartments at Toscana Apartments in South Westminster. Enjoy modern amenities in a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-arvada-co",
      "search_query": "1 bedroom apartments arvada co",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Arvada, CO",
      "h2_subtitle": "Explore elegant one-bedroom apartments at Toscana Apartments, located in charming Arvada, CO. Enjoy a community full of top-notch amenities.",
      "page_copy": "Located in the vibrant city of Arvada, CO, Toscana Apartments offers exquisite one-bedroom apartments tailored to your lifestyle needs. Each unit is thoughtfully designed, providing comfort and convenience with upscale features such as a balcony and spacious living areas.\n\nResidents have access to community amenities including a refreshing pool, business center, and pet-friendly dog park. Positioned perfectly in Arvada, Toscana Apartments offers a great location with easy access to local dining and entertainment options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Arvada, CO",
      "seo_description": "Discover charming one-bedroom apartments in Arvada, CO at Toscana Apartments. Enjoy modern amenities in a beautiful community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-adams-county",
      "search_query": "2 bedroom apartments adams county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Adams County",
      "h2_subtitle": "Discover spacious two-bedroom apartments at Toscana Apartments, nestled in the welcoming community of Adams County.",
      "page_copy": "At Toscana Apartments, located in the heart of Adams County, you’ll find thoughtfully designed two-bedroom apartments that cater to a comfortable lifestyle. Featuring modern amenities like a fully-equipped kitchen with a refrigerator, these homes provide both style and functionality.\n\nResidents enjoy access to exceptional community amenities, including a pet-friendly dog park, a sparkling pool, and a welcoming clubhouse. Positioned in a charming neighborhood, Toscana Apartments offers a perfect blend of tranquility and convenience in Adams County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Adams County",
      "seo_description": "Find spacious two-bedroom apartments in Adams County at Toscana Apartments, offering modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "apartments-near-mesa-elementary-school-arvada",
      "search_query": "apartments near Mesa Elementary School Arvada",
      "category": "School",
      "h1_title": "Apartments Near Mesa Elementary School",
      "h2_subtitle": "Located close to Mesa Elementary School, Toscana Apartments in Arvada offers spacious living with top amenities and a family-friendly atmosphere.",
      "page_copy": "Toscana Apartments provides an ideal living environment for families looking to settle near Mesa Elementary School in Arvada. Our community features stylish studio, one, and two-bedroom options, perfect for those seeking comfort and convenience.\n\nEnjoy easy access to educational facilities and a host of on-site amenities including a refreshing pool and a welcoming clubhouse. With its proximity to Mesa Elementary, Toscana Apartments creates a supportive and vibrant neighborhood atmosphere for residents of all ages.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mesa Elementary School",
      "seo_description": "Find family-friendly apartments near Mesa Elementary School in Arvada at Toscana Apartments, offering excellent amenities and community features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "south-westminster-apartments-near-shaw-heights-middle-school",
      "search_query": "South Westminster apartments near Shaw Heights Middle School",
      "category": "School",
      "h1_title": "Apartments Near Shaw Heights Middle School",
      "h2_subtitle": "Discover South Westminster's Toscana Apartments, conveniently located near Shaw Heights Middle School, offering vibrant community living.",
      "page_copy": "For families seeking quality education and convenience, Toscana Apartments in South Westminster offers a perfect location near Shaw Heights Middle School. These well-appointed studio, one, and two-bedroom apartments blend comfort with style, ensuring a welcoming home environment.\n\nThe community features a range of amenities, including a business center and pet-friendly dog park, catering to diverse lifestyles. Enjoy the ease of living close to educational facilities while benefiting from a rich community atmosphere at Toscana Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Shaw Heights Middle School",
      "seo_description": "Explore South Westminster apartments near Shaw Heights Middle School at Toscana, offering family-friendly amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "tennyson-knolls-preparatory-school-nearby-apartments",
      "search_query": "Tennyson Knolls Preparatory School nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near Tennyson Knolls Prep School",
      "h2_subtitle": "Explore nearby apartments at Toscana, just minutes from Tennyson Knolls Preparatory School, where comfort meets convenience.",
      "page_copy": "At Toscana Apartments in South Westminster, you can enjoy the perfect blend of comfort and convenience near Tennyson Knolls Preparatory School. Our community offers a selection of studio, one, and two-bedroom floor plans designed to meet the needs of families and individuals alike.\n\nLiving at Toscana means having access to premium amenities such as a lounge, a refreshing pool, and a welcoming business center, all while being just a short distance from Tennyson Knolls Preparatory School. Experience a vibrant community that's close to all life's essentials.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tennyson Knolls Prep School",
      "seo_description": "Discover nearby apartments at Toscana, close to Tennyson Knolls Preparatory School, featuring modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "westminster-high-school-close-by-apartments",
      "search_query": "Westminster High School close by apartments",
      "category": "School",
      "h1_title": "Apartments Near Westminster High School",
      "h2_subtitle": "Discover Toscana Apartments, conveniently close to Westminster High School, offering a range of modern amenities and spacious living.",
      "page_copy": "Toscana Apartments provides the ideal setting for those seeking residences close to Westminster High School. Our selection of studio, one, and two-bedroom apartments ensures that every family can find their perfect home.\n\nLocated in the vibrant South Westminster area, our community offers lifestyle-enhancing amenities, including a refreshing pool, a dog park, and a welcoming clubhouse. With the advantage of being near a prominent educational institution like Westminster High School, Toscana Apartments is a fantastic choice for convenient and comfortable living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Westminster High School",
      "seo_description": "Find modern apartments close to Westminster High School at Toscana, featuring diverse amenities and a community-centered atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "apartments-near-hidden-lake-secondary-school-co",
      "search_query": "Apartments near Hidden Lake Secondary School CO",
      "category": "School",
      "h1_title": "Apartments by Hidden Lake Secondary School",
      "h2_subtitle": "Experience living at Toscana Apartments, conveniently located near Hidden Lake Secondary School in CO, offering modern living options.",
      "page_copy": "Toscana Apartments, located in South Westminster, CO, provides comfortable and stylish living options near Hidden Lake Secondary School. With studio, one, and two-bedroom floor plans, you'll find the ideal space to suit your needs.\n\nOur community features attractive amenities like a relaxing pool, a business center, and pet-friendly facilities. Living at Toscana means enjoying the benefits of being close to an esteemed school while immersing yourself in a vibrant community setting. Your new home in Arvada, CO, awaits your visit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Hidden Lake Secondary School, CO",
      "seo_description": "Discover Toscana Apartments near Hidden Lake Secondary School, CO. Enjoy community amenities and a prime location in South Westminster.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "belleview-christian-school-arvada-apartment-listings",
      "search_query": "Belleview Christian School Arvada apartment listings",
      "category": "School",
      "h1_title": "Arvada Apartments Near Belleview Christian School",
      "h2_subtitle": "Explore Toscana Apartments in Arvada, featuring listings near Belleview Christian School. Perfect for families and individuals seeking convenience.",
      "page_copy": "Toscana Apartments in Arvada, CO, offers ideal living spaces for those seeking proximity to Belleview Christian School. Our carefully curated selection of studio, one, and two-bedroom floor plans caters to diverse needs and preferences.\n\nResidents of Toscana enjoy exclusive access to amenities such as a refreshing pool, a welcoming lounge, and a modern business center. Nestled in the thriving South Westminster neighborhood, our community grants you both the tranquility of a suburban setting and the convenience of nearby educational institutions, including Belleview Christian School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Arvada Apartments Near Belleview Christian School",
      "seo_description": "Find the perfect apartment near Belleview Christian School at Toscana Apartments, offering great amenities in Arvada, CO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "adams-county-apartments-near-colorado-preparatory-academy",
      "search_query": "Adams County apartments near Colorado Preparatory Academy",
      "category": "School",
      "h1_title": "Apartments Near Colorado Preparatory Academy",
      "h2_subtitle": "Discover comfortable living at Toscana Apartments, situated conveniently near Colorado Preparatory Academy in Adams County.",
      "page_copy": "Toscana Apartments in Adams County is the perfect choice for those looking to live near Colorado Preparatory Academy. Offering diverse floor plans including studio, one, and two-bedroom options, Toscana Apartments cater to various lifestyles and needs.\n\nOur community is designed with residents in mind, featuring top-notch amenities such as a sparkling pool, a business center, and a friendly pet park. The South Westminster neighborhood provides a vibrant living environment, perfectly pairing comfort with the practical convenience of being close to Colorado Preparatory Academy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Adams County Apartments Near Colorado Prep Academy",
      "seo_description": "Toscana Apartments in Adams County offers convenient living near Colorado Preparatory Academy with great amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "front-range-community-college-westminster-nearby-housing",
      "search_query": "Front Range Community College Westminster nearby housing",
      "category": "School",
      "h1_title": "Housing Near Front Range Community College",
      "h2_subtitle": "Explore Toscana Apartments, offering nearby housing options close to Front Range Community College in Westminster.",
      "page_copy": "Toscana Apartments in South Westminster provides ideal nearby housing solutions for students and staff of Front Range Community College. Offering a range of studio, one, and two-bedroom layouts, our apartments cater to diverse living preferences.\n\nResidents enjoy a variety of amenities, such as a relaxing pool, a business center, and social lounge areas. Located in proximity to Front Range Community College, Toscana Apartments combine the benefits of modern living with the convenience of a short commute, making it the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Front Range Community College Westminster",
      "seo_description": "Discover nearby housing at Toscana Apartments near Front Range Community College in Westminster with modern amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "red-rocks-community-college-arvada-campus-apartments",
      "search_query": "Red Rocks Community College Arvada Campus apartments",
      "category": "School",
      "h1_title": "Apartments Near Red Rocks Community College",
      "h2_subtitle": "Toscana Apartments offers convenient living options near Red Rocks Community College Arvada Campus, perfect for students and faculty.",
      "page_copy": "Located just a short drive from Red Rocks Community College Arvada Campus, Toscana Apartments provides students and staff with superb living options. Our community offers stylish studio, one, and two-bedroom apartments, tailored to fit a variety of lifestyles.\n\nEnjoy a host of amenities including a refreshing pool, a dog-friendly park, and a welcoming clubhouse that enhance both study and relaxation. Toscana Apartments in South Westminster perfectly blends comfort and convenience, creating an ideal setting for academic and personal success near Red Rocks Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Red Rocks Community College Arvada",
      "seo_description": "Find ideal living at Toscana Apartments near Red Rocks Community College Arvada Campus, offering great amenities and spacious layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "apartments-near-north-suburban-medical-center-arvada",
      "search_query": "apartments near North Suburban Medical Center Arvada",
      "category": "Hospital",
      "h1_title": "Apartments Near North Suburban Medical Center",
      "h2_subtitle": "Live conveniently close to North Suburban Medical Center at Toscana Apartments, offering ideal accommodations in Arvada.",
      "page_copy": "Toscana Apartments is perfectly located for those seeking living options near North Suburban Medical Center in Arvada. Our community offers a variety of living spaces including studio, one, and two-bedroom apartments, each designed with comfort and practicality in mind.\n\nResidents enjoy superior amenities such as a sparkling pool, a pet-friendly park, and a business center that supports both work and leisure activities. With its favorable location near North Suburban Medical Center, Toscana Apartments is the prime choice for healthcare professionals and patients seeking nearby accommodations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near North Suburban Medical Center",
      "seo_description": "Discover Toscana Apartments near North Suburban Medical Center in Arvada, featuring spacious layouts and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "toscana-apartments-close-to-uchealth-broomfield-hospital",
      "search_query": "Toscana Apartments close to UCHealth Broomfield Hospital",
      "category": "Hospital",
      "h1_title": "Toscana Apartments Near UCHealth Broomfield",
      "h2_subtitle": "Experience convenient living at Toscana Apartments, located close to UCHealth Broomfield Hospital, ideal for healthcare staff and visitors.",
      "page_copy": "Toscana Apartments provides a convenient living solution for those requiring easy access to UCHealth Broomfield Hospital. Our community features modern studio, one, and two-bedroom apartments designed with style and functionality.\n\nResidents benefit from a range of amenities, including a relaxing pool, a welcoming clubhouse, and a pet-friendly area, making it a great place for both downtime and companionship. The proximity of Toscana Apartments to UCHealth Broomfield Hospital ensures that healthcare professionals and patients can enjoy a seamless balance of work and home life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Toscana Apartments Near UCHealth Broomfield",
      "seo_description": "Find ideal living at Toscana Apartments, located close to UCHealth Broomfield Hospital. Enjoy modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "apartments-near-lake-arbor-park-arvada-co",
      "search_query": "apartments near Lake Arbor Park Arvada CO",
      "category": "Park",
      "h1_title": "Apartments Close to Lake Arbor Park",
      "h2_subtitle": "Discover the ideal apartments near Lake Arbor Park in Arvada, CO. Toscana Apartments offers an exceptional living experience near this beautiful park.",
      "page_copy": "Located near the scenic Lake Arbor Park in Arvada, CO, Toscana Apartments provides residents with a perfect blend of nature and modern living. Offering studio, one, and two-bedroom apartments, our community is designed for those who appreciate both comfort and proximity to green spaces.\n\nToscana Apartments boasts amenities such as a serene pool, a business center for productivity, and pet-friendly areas for your four-legged companions. Whether you're enjoying a stroll through Lake Arbor Park or relaxing in our welcoming clubhouse, you’ll find the ideal balance of recreation and relaxation here at Toscana Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Lake Arbor Park Arvada, CO",
      "seo_description": "Live near Lake Arbor Park in Arvada, CO, at Toscana Apartments. Enjoy great amenities and beautiful surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "toscana-apartments-close-to-ralston-central-park",
      "search_query": "Toscana Apartments close to Ralston Central Park",
      "category": "Park",
      "h1_title": "Toscana Apartments Near Ralston Central Park",
      "h2_subtitle": "Enjoy living at Toscana Apartments, conveniently located close to Ralston Central Park, where urban life meets nature.",
      "page_copy": "Experience vibrant living at Toscana Apartments, conveniently situated near Ralston Central Park in Arvada. Our stylish studio, one, and two-bedroom apartments offer comfort, alongside superb amenities that cater to both leisure and work.\n\nWith direct access to Ralston Central Park, residents can easily enjoy the outdoors, whether it's picnicking, strolling, or taking advantage of the park’s open spaces. Within the community, enjoy a pool for relaxation, a business center, and a lounge area, all contributing to a balanced and enjoyable lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Toscana Apartments Near Ralston Central Park",
      "seo_description": "Discover Toscana Apartments near Ralston Central Park, combining modern living with easy park access and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "gold-strike-park-nearby-apartments-south-westminster",
      "search_query": "Gold Strike Park nearby apartments South Westminster",
      "category": "Park",
      "h1_title": "Apartments Near Gold Strike Park South Westminster",
      "h2_subtitle": "Find a perfect home near Gold Strike Park in South Westminster at Toscana Apartments, offering excellent amenities and access to nature.",
      "page_copy": "Located in the charming area of South Westminster, Toscana Apartments offers convenient access to Gold Strike Park, making it an ideal choice for nature lovers. Our community features a range of floor plans, from stylish studios to spacious two-bedroom apartments, ensuring there's a home to fit every lifestyle.\n\nWith Gold Strike Park just around the corner, enjoy outdoor activities or leisurely walks. Toscana Apartments complements this with amenities such as a refreshing pool, a welcoming lounge, and a pet-friendly park, creating a vibrant community that caters to both relaxation and active living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Gold Strike Park South Westminster",
      "seo_description": "Live near Gold Strike Park in South Westminster at Toscana Apartments. Enjoy modern living with lush park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-near-west-arvada-dog-park",
      "search_query": "pet-friendly apartments near West Arvada Dog Park",
      "category": "Park",
      "h1_title": "Pet-Friendly Apartments Near West Arvada Dog Park",
      "h2_subtitle": "Explore Toscana Apartments, offering pet-friendly living near West Arvada Dog Park, perfect for you and your furry friends.",
      "page_copy": "At Toscana Apartments, we understand the importance of finding a home that suits both you and your pets, which is why we are thrilled to offer pet-friendly living near West Arvada Dog Park. Our studio, one, and two-bedroom apartments provide a comfortable and welcoming environment for you and your four-legged companions.\n\nWith West Arvada Dog Park nearby, enjoy ample space for your pets to play and socialize. On-site, our own pet-friendly dog park, along with amenities like a refreshing pool and a welcoming clubhouse, ensure a lifestyle that's both convenient and enjoyable for you and your furry friends.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near West Arvada Dog Park",
      "seo_description": "Discover pet-friendly living at Toscana Apartments near West Arvada Dog Park, ideal for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "long-lake-regional-park-close-by-adams-county-apartments",
      "search_query": "Long Lake Regional Park close by Adams County apartments",
      "category": "Park",
      "h1_title": "Adams County Apartments Near Long Lake Regional Park",
      "h2_subtitle": "Discover the joys of living in Adams County at Toscana Apartments, conveniently close to Long Lake Regional Park.",
      "page_copy": "Nestled in Adams County, Toscana Apartments offers a perfect blend of modern living and natural beauty, situated close to Long Lake Regional Park. Choose from a variety of floor plans, including stylish studios and spacious two-bedroom options, each designed for comfort and convenience.\n\nLiving near Long Lake Regional Park means residents can enjoy outdoor activities like hiking and picnicking with ease. At home, Toscana Apartments provides top-tier amenities such as a refreshing pool and a business center, ensuring relaxation and productivity are always within reach.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Adams County Apartments Near Long Lake Regional Park",
      "seo_description": "Live in Adams County at Toscana Apartments, close by Long Lake Regional Park, offering modern homes and nature access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "majestic-view-nature-center-nearby-toscana-apartments",
      "search_query": "Majestic View Nature Center nearby Toscana Apartments",
      "category": "Park",
      "h1_title": "Toscana Apartments Near Majestic View Nature Center",
      "h2_subtitle": "Discover comfortable living at Toscana Apartments, conveniently located near the serene Majestic View Nature Center.",
      "page_copy": "Toscana Apartments offers an unbeatable location near the Majestic View Nature Center, providing residents with easy access to natural beauty and outdoor adventures. Our community in Arvada, CO, features a range of living spaces from cozy studios to roomy two-bedroom apartments, all designed with your lifestyle in mind.\n\nJust a short distance from the Majestic View Nature Center, residents can indulge in hiking, wildlife viewing, and exploring nature exhibits. Within Toscana Apartments, enjoy a refreshing pool, a cozy clubhouse, and our pet-friendly amenities, creating a harmonious blend of comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Toscana Apartments Near Majestic View Nature Center",
      "seo_description": "Toscana Apartments offers modern living near Majestic View Nature Center in Arvada, perfect for nature enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166942",
      "source": "generator",
      "page_item_url": "apartments-near-denver-international-airport-arvada-co",
      "search_query": "apartments near denver international airport arvada co",
      "category": "Transit",
      "h1_title": "Apartments Near Denver International Airport",
      "h2_subtitle": "Find convenient living at Toscana Apartments in Arvada, CO, located near Denver International Airport, ideal for frequent travelers.",
      "page_copy": "Toscana Apartments in Arvada, CO, offers an ideal location for those seeking proximity to Denver International Airport. Our community provides an array of modern living options, from cozy studios to spacious two-bedroom apartments, suitable for any lifestyle.\n\nWith Denver International Airport just a drive away, commuting is a breeze, making Toscana Apartments perfect for frequent flyers and professionals. Residents also enjoy a vibrant community with amenities like a refreshing pool, a business center, and our welcoming clubhouse, ensuring an enjoyable and practical living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
      "featured_image_media": {
        "alt_text": "Toscana Apartment Homes monument sign with flowers and building in background.",
        "public_id": "019d02d3-1bfb-77dc-bfe7-14bc240e0f29",
        "storage_key": "property/6767906449166942/019d02d3-1bfb-77dc-bfe7-14bc240e0f29.webp",
        "width": 1161,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Denver International Airport Arvada",
      "seo_description": "Discover Toscana Apartments in Arvada, close to Denver International Airport, offering comfort and convenience for travelers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5735"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10693015982"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5WC498RF"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "1138TOSC"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "6732006317"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "ER100107678"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC_LLC/Toscana/scheduletourwidget/z15vFhheQ3R4VzgeEH/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkJmcXBxTG5RMGRoMUFPRUdqbGNtR1E9PSIsInZhbHVlIjoiL0M5YkVjUlo0b2tua0dUdFB3REF5QT09IiwibWFjIjoiYzI1Yjk3NjJhOTRkMjFkMzkzZDY0ODdlOTFmNzE5MzY4NGQ2MTViMjQyOTBmNmIxYTBmMGM4MDg0NGY1MDU4MSJ9"
    }
  ],
  "custom_qb_id": "5735",
  "custom_repli_id": "10693015982",
  "custom_google_gtm_id": "GTM-5WC498RF",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Preferred",
  "custom_aim_property_code": "1138TOSC",
  "custom_hubspot_company_id": "6732006317",
  "custom_broker_license_number": "ER100107678",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC_LLC/Toscana/scheduletourwidget/z15vFhheQ3R4VzgeEH/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkJmcXBxTG5RMGRoMUFPRUdqbGNtR1E9PSIsInZhbHVlIjoiL0M5YkVjUlo0b2tua0dUdFB3REF5QT09IiwibWFjIjoiYzI1Yjk3NjJhOTRkMjFkMzkzZDY0ODdlOTFmNzE5MzY4NGQ2MTViMjQyOTBmNmIxYTBmMGM4MDg0NGY1MDU4MSJ9",
  "custom_audioeye_site_id": "adbf98a6-dc6c-493a-920b-134196d2614b",
  "custom_audioeye_site_hash": "7a9c3d12de5f61d8f87954590ad91077"
};

export const generatedAt = '2026-10-05T17:25:38.927Z';
